(function () {
/*! modernizr 3.11.2 (Custom Build) | MIT *
 * https://modernizr.com/download/?-cssanimations-csscolumns-customelements-flexbox-history-picture-pointerevents-postmessage-sizes-srcset-webgl-websockets-webworkers-addtest-domprefixes-hasevent-mq-prefixedcssvalue-prefixes-setclasses-testallprops-testprop-teststyles !*/ !function(e, t, n, r) {
    function o(e, t) {
        return typeof e === t;
    }
    function i(e) {
        var t = _.className, n = Modernizr._config.classPrefix || "";
        if (S && (t = t.baseVal), Modernizr._config.enableJSClass) {
            var r = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
            t = t.replace(r, "$1" + n + "js$2");
        }
        Modernizr._config.enableClasses && (e.length > 0 && (t += " " + n + e.join(" " + n)), S ? _.className.baseVal = t : _.className = t);
    }
    function s(e, t) {
        if ("object" == typeof e) for(var n in e)k(e, n) && s(n, e[n]);
        else {
            e = e.toLowerCase();
            var r = e.split("."), o = Modernizr[r[0]];
            if (2 === r.length && (o = o[r[1]]), void 0 !== o) return Modernizr;
            t = "function" == typeof t ? t() : t, 1 === r.length ? Modernizr[r[0]] = t : (!Modernizr[r[0]] || Modernizr[r[0]] instanceof Boolean || (Modernizr[r[0]] = new Boolean(Modernizr[r[0]])), Modernizr[r[0]][r[1]] = t), i([
                (t && !1 !== t ? "" : "no-") + r.join("-")
            ]), Modernizr._trigger(e, t);
        }
        return Modernizr;
    }
    function a() {
        return "function" != typeof n.createElement ? n.createElement(arguments[0]) : S ? n.createElementNS.call(n, "http://www.w3.org/2000/svg", arguments[0]) : n.createElement.apply(n, arguments);
    }
    function l() {
        var e = n.body;
        return e || (e = a(S ? "svg" : "body"), e.fake = !0), e;
    }
    function u(e, t, r, o) {
        var i, s, u, f, c = "modernizr", d = a("div"), p = l();
        if (parseInt(r, 10)) for(; r--;)u = a("div"), u.id = o ? o[r] : c + (r + 1), d.appendChild(u);
        return i = a("style"), i.type = "text/css", i.id = "s" + c, (p.fake ? p : d).appendChild(i), p.appendChild(d), i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(n.createTextNode(e)), d.id = c, p.fake && (p.style.background = "", p.style.overflow = "hidden", f = _.style.overflow, _.style.overflow = "hidden", _.appendChild(p)), s = t(d, e), p.fake ? (p.parentNode.removeChild(p), _.style.overflow = f, _.offsetHeight) : d.parentNode.removeChild(d), !!s;
    }
    function f(e, n, r) {
        var o;
        if ("getComputedStyle" in t) {
            o = getComputedStyle.call(t, e, n);
            var i = t.console;
            if (null !== o) r && (o = o.getPropertyValue(r));
            else if (i) {
                var s = i.error ? "error" : "log";
                i[s].call(i, "getComputedStyle returning null, its possible modernizr test results are inaccurate");
            }
        } else o = !n && e.currentStyle && e.currentStyle[r];
        return o;
    }
    function c(e, t) {
        return !!~("" + e).indexOf(t);
    }
    function d(e) {
        return e.replace(/([A-Z])/g, function(e, t) {
            return "-" + t.toLowerCase();
        }).replace(/^ms-/, "-ms-");
    }
    function p(e, n) {
        var o = e.length;
        if ("CSS" in t && "supports" in t.CSS) {
            for(; o--;)if (t.CSS.supports(d(e[o]), n)) return !0;
            return !1;
        }
        if ("CSSSupportsRule" in t) {
            for(var i = []; o--;)i.push("(" + d(e[o]) + ":" + n + ")");
            return i = i.join(" or "), u("@supports (" + i + ") { #modernizr { position: absolute; } }", function(e) {
                return "absolute" === f(e, null, "position");
            });
        }
        return r;
    }
    function m(e) {
        return e.replace(/([a-z])-([a-z])/g, function(e, t, n) {
            return t + n.toUpperCase();
        }).replace(/^-/, "");
    }
    function h(e, t, n, i) {
        function s() {
            u && (delete N.style, delete N.modElem);
        }
        if (i = !o(i, "undefined") && i, !o(n, "undefined")) {
            var l = p(e, n);
            if (!o(l, "undefined")) return l;
        }
        for(var u, f, d, h, A, v = [
            "modernizr",
            "tspan",
            "samp"
        ]; !N.style && v.length;)u = !0, N.modElem = a(v.shift()), N.style = N.modElem.style;
        for(d = e.length, f = 0; f < d; f++)if (h = e[f], A = N.style[h], c(h, "-") && (h = m(h)), N.style[h] !== r) {
            if (i || o(n, "undefined")) return s(), "pfx" !== t || h;
            try {
                N.style[h] = n;
            } catch (e) {}
            if (N.style[h] !== A) return s(), "pfx" !== t || h;
        }
        return s(), !1;
    }
    function A(e, t) {
        return function() {
            return e.apply(t, arguments);
        };
    }
    function v(e, t, n) {
        var r;
        for(var i in e)if (e[i] in t) return !1 === n ? e[i] : (r = t[e[i]], o(r, "function") ? A(r, n || t) : r);
        return !1;
    }
    function g(e, t, n, r, i) {
        var s = e.charAt(0).toUpperCase() + e.slice(1), a = (e + " " + O.join(s + " ") + s).split(" ");
        return o(t, "string") || o(t, "undefined") ? h(a, t, r, i) : (a = (e + " " + T.join(s + " ") + s).split(" "), v(a, t, n));
    }
    function y(e, t, n) {
        return g(e, r, r, t, n);
    }
    var w = [], C = {
        _version: "3.11.2",
        _config: {
            classPrefix: "",
            enableClasses: !0,
            enableJSClass: !0,
            usePrefixes: !0
        },
        _q: [],
        on: function(e, t) {
            var n = this;
            setTimeout(function() {
                t(n[e]);
            }, 0);
        },
        addTest: function(e, t, n) {
            w.push({
                name: e,
                fn: t,
                options: n
            });
        },
        addAsyncTest: function(e) {
            w.push({
                name: null,
                fn: e
            });
        }
    }, Modernizr = function() {};
    Modernizr.prototype = C, Modernizr = new Modernizr;
    var b = [], _ = n.documentElement, S = "svg" === _.nodeName.toLowerCase(), x = "Moz O ms Webkit", T = C._config.usePrefixes ? x.toLowerCase().split(" ") : [];
    C._domPrefixes = T;
    var P = C._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : [
        "",
        ""
    ];
    C._prefixes = P;
    var k;
    !function() {
        var e = {}.hasOwnProperty;
        k = o(e, "undefined") || o(e.call, "undefined") ? function(e, t) {
            return t in e && o(e.constructor.prototype[t], "undefined");
        } : function(t, n) {
            return e.call(t, n);
        };
    }(), C._l = {}, C.on = function(e, t) {
        this._l[e] || (this._l[e] = []), this._l[e].push(t), Modernizr.hasOwnProperty(e) && setTimeout(function() {
            Modernizr._trigger(e, Modernizr[e]);
        }, 0);
    }, C._trigger = function(e, t) {
        if (this._l[e]) {
            var n = this._l[e];
            setTimeout(function() {
                var e;
                for(e = 0; e < n.length; e++)(0, n[e])(t);
            }, 0), delete this._l[e];
        }
    }, Modernizr._q.push(function() {
        C.addTest = s;
    });
    var E = function() {
        function e(e, n) {
            var o;
            return !!e && (n && "string" != typeof n || (n = a(n || "div")), e = "on" + e, o = e in n, !o && t && (n.setAttribute || (n = a("div")), n.setAttribute(e, ""), o = "function" == typeof n[e], n[e] !== r && (n[e] = r), n.removeAttribute(e)), o);
        }
        var t = !("onblur" in _);
        return e;
    }();
    C.hasEvent = E;
    var B = function() {
        var e = t.matchMedia || t.msMatchMedia;
        return e ? function(t) {
            var n = e(t);
            return n && n.matches || !1;
        } : function(e) {
            var t = !1;
            return u("@media " + e + " { #modernizr { position: absolute; } }", function(e) {
                t = "absolute" === f(e, null, "position");
            }), t;
        };
    }();
    C.mq = B;
    var z = function(e, t) {
        var n = !1, r = a("div"), o = r.style;
        if (e in o) {
            var i = T.length;
            for(o[e] = t, n = o[e]; i-- && !n;)o[e] = "-" + T[i] + "-" + t, n = o[e];
        }
        return "" === n && (n = !1), n;
    };
    C.prefixedCSSValue = z;
    var O = C._config.usePrefixes ? x.split(" ") : [];
    C._cssomPrefixes = O;
    var L = {
        elem: a("modernizr")
    };
    Modernizr._q.push(function() {
        delete L.elem;
    });
    var N = {
        style: L.elem.style
    };
    Modernizr._q.unshift(function() {
        delete N.style;
    }), C.testAllProps = g, C.testAllProps = y;
    C.testProp = function(e, t, n) {
        return h([
            e
        ], r, t, n);
    }, C.testStyles = u;
    Modernizr.addTest("customelements", "customElements" in t), Modernizr.addTest("history", function() {
        var e = navigator.userAgent;
        return !!e && (-1 === e.indexOf("Android 2.") && -1 === e.indexOf("Android 4.0") || -1 === e.indexOf("Mobile Safari") || -1 !== e.indexOf("Chrome") || -1 !== e.indexOf("Windows Phone") || "file:" === location.protocol) && t.history && "pushState" in t.history;
    });
    var R = [
        ""
    ].concat(T);
    C._domPrefixesAll = R, Modernizr.addTest("pointerevents", function() {
        for(var e = 0, t = R.length; e < t; e++)if (E(R[e] + "pointerdown")) return !0;
        return !1;
    });
    var j = !0;
    try {
        t.postMessage({
            toString: function() {
                j = !1;
            }
        }, "*");
    } catch (e) {}
    Modernizr.addTest("postmessage", new Boolean("postMessage" in t)), Modernizr.addTest("postmessage.structuredclones", j), Modernizr.addTest("webgl", function() {
        return "WebGLRenderingContext" in t;
    });
    var M = !1;
    try {
        M = "WebSocket" in t && 2 === t.WebSocket.CLOSING;
    } catch (e) {}
    Modernizr.addTest("websockets", M), Modernizr.addTest("cssanimations", y("animationName", "a", !0)), function() {
        Modernizr.addTest("csscolumns", function() {
            var e = !1, t = y("columnCount");
            try {
                e = !!t, e && (e = new Boolean(e));
            } catch (e) {}
            return e;
        });
        for(var e, t, n = [
            "Width",
            "Span",
            "Fill",
            "Gap",
            "Rule",
            "RuleColor",
            "RuleStyle",
            "RuleWidth",
            "BreakBefore",
            "BreakAfter",
            "BreakInside"
        ], r = 0; r < n.length; r++)e = n[r].toLowerCase(), t = y("column" + n[r]), "breakbefore" !== e && "breakafter" !== e && "breakinside" !== e || (t = t || y(n[r])), Modernizr.addTest("csscolumns." + e, t);
    }(), Modernizr.addTest("flexbox", y("flexBasis", "1px", !0)), Modernizr.addTest("picture", "HTMLPictureElement" in t), Modernizr.addAsyncTest(function() {
        var e, t, n, r = a("img"), o = "sizes" in r;
        !o && "srcset" in r ? (t = "data:image/gif;base64,R0lGODlhAgABAPAAAP///wAAACH5BAAAAAAALAAAAAACAAEAAAICBAoAOw==", e = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==", n = function() {
            s("sizes", 2 === r.width);
        }, r.onload = n, r.onerror = n, r.setAttribute("sizes", "9px"), r.srcset = e + " 1w," + t + " 8w", r.src = e) : s("sizes", o);
    }), Modernizr.addTest("srcset", "srcset" in a("img")), Modernizr.addTest("webworkers", "Worker" in t), function() {
        var e, t, n, r, i, s, a;
        for(var l in w)if (w.hasOwnProperty(l)) {
            if (e = [], t = w[l], t.name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length)) for(n = 0; n < t.options.aliases.length; n++)e.push(t.options.aliases[n].toLowerCase());
            for(r = o(t.fn, "function") ? t.fn() : t.fn, i = 0; i < e.length; i++)s = e[i], a = s.split("."), 1 === a.length ? Modernizr[a[0]] = r : (Modernizr[a[0]] && (!Modernizr[a[0]] || Modernizr[a[0]] instanceof Boolean) || (Modernizr[a[0]] = new Boolean(Modernizr[a[0]])), Modernizr[a[0]][a[1]] = r), b.push((r ? "" : "no-") + a.join("-"));
        }
    }(), i(b), delete C.addTest, delete C.addAsyncTest;
    for(var W = 0; W < Modernizr._q.length; W++)Modernizr._q[W]();
    e.Modernizr = Modernizr;
}(window, window, document);


// Avoid `console` errors in browsers that lack a console.
(function() {
    var method;
    var noop = function() {};
    var methods = [
        "assert",
        "clear",
        "count",
        "debug",
        "dir",
        "dirxml",
        "error",
        "exception",
        "group",
        "groupCollapsed",
        "groupEnd",
        "info",
        "log",
        "markTimeline",
        "profile",
        "profileEnd",
        "table",
        "time",
        "timeEnd",
        "timeline",
        "timelineEnd",
        "timeStamp",
        "trace",
        "warn"
    ];
    var length = methods.length;
    var console = window.console = window.console || {};
    while(length--){
        method = methods[length];
        // Only stub undefined methods.
        if (!console[method]) console[method] = noop;
    }
})(); // Place any jQuery/helper plugins in here.


/*!
 * Glide.js v3.6.0
 * (c) 2013-2022 Jędrzej Chałubek (https://github.com/jedrzejchalubek/)
 * Released under the MIT License.
 */ function $18c4610f4512b4f1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $18c4610f4512b4f1$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $18c4610f4512b4f1$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $18c4610f4512b4f1$var$_typeof(obj);
}
function $18c4610f4512b4f1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $18c4610f4512b4f1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $18c4610f4512b4f1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $18c4610f4512b4f1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $18c4610f4512b4f1$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $18c4610f4512b4f1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $18c4610f4512b4f1$var$_setPrototypeOf(subClass, superClass);
}
function $18c4610f4512b4f1$var$_getPrototypeOf(o) {
    $18c4610f4512b4f1$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $18c4610f4512b4f1$var$_getPrototypeOf(o);
}
function $18c4610f4512b4f1$var$_setPrototypeOf(o, p) {
    $18c4610f4512b4f1$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $18c4610f4512b4f1$var$_setPrototypeOf(o, p);
}
function $18c4610f4512b4f1$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $18c4610f4512b4f1$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $18c4610f4512b4f1$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $18c4610f4512b4f1$var$_assertThisInitialized(self);
}
function $18c4610f4512b4f1$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $18c4610f4512b4f1$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $18c4610f4512b4f1$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $18c4610f4512b4f1$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $18c4610f4512b4f1$var$_possibleConstructorReturn(this, result);
    };
}
function $18c4610f4512b4f1$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $18c4610f4512b4f1$var$_getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function $18c4610f4512b4f1$var$_get() {
    if (typeof Reflect !== "undefined" && Reflect.get) $18c4610f4512b4f1$var$_get = Reflect.get;
    else $18c4610f4512b4f1$var$_get = function _get(target, property, receiver) {
        var base = $18c4610f4512b4f1$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(arguments.length < 3 ? target : receiver);
        return desc.value;
    };
    return $18c4610f4512b4f1$var$_get.apply(this, arguments);
}
var $18c4610f4512b4f1$var$defaults = {
    /**
   * Type of the movement.
   *
   * Available types:
   * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
   * `carousel` - Changes slides without starting over when it reaches the first or last slide.
   *
   * @type {String}
   */ type: "slider",
    /**
   * Start at specific slide number defined with zero-based index.
   *
   * @type {Number}
   */ startAt: 0,
    /**
   * A number of slides visible on the single viewport.
   *
   * @type {Number}
   */ perView: 1,
    /**
   * Focus currently active slide at a specified position in the track.
   *
   * Available inputs:
   * `center` - Current slide will be always focused at the center of a track.
   * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
   *
   * @type {String|Number}
   */ focusAt: 0,
    /**
   * A size of the gap added between slides.
   *
   * @type {Number}
   */ gap: 10,
    /**
   * Change slides after a specified interval. Use `false` for turning off autoplay.
   *
   * @type {Number|Boolean}
   */ autoplay: false,
    /**
   * Stop autoplay on mouseover event.
   *
   * @type {Boolean}
   */ hoverpause: true,
    /**
   * Allow for changing slides with left and right keyboard arrows.
   *
   * @type {Boolean}
   */ keyboard: true,
    /**
   * Stop running `perView` number of slides from the end. Use this
   * option if you don't want to have an empty space after
   * a slider. Works only with `slider` type and a
   * non-centered `focusAt` setting.
   *
   * @type {Boolean}
   */ bound: false,
    /**
   * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
   *
   * @type {Number|Boolean}
   */ swipeThreshold: 80,
    /**
   * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
   *
   * @type {Number|Boolean}
   */ dragThreshold: 120,
    /**
   * A number of slides moved on single swipe.
   *
   * Available types:
   * `` - Moves slider by one slide per swipe
   * `|` - Moves slider between views per swipe (number of slides defined in `perView` options)
   *
   * @type {String}
   */ perSwipe: "",
    /**
   * Moving distance ratio of the slides on a swiping and dragging.
   *
   * @type {Number}
   */ touchRatio: 0.5,
    /**
   * Angle required to activate slides moving on swiping or dragging.
   *
   * @type {Number}
   */ touchAngle: 45,
    /**
   * Duration of the animation in milliseconds.
   *
   * @type {Number}
   */ animationDuration: 400,
    /**
   * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
   *
   * @type {Boolean}
   */ rewind: true,
    /**
   * Duration of the rewinding animation of the `slider` type in milliseconds.
   *
   * @type {Number}
   */ rewindDuration: 800,
    /**
   * Easing function for the animation.
   *
   * @type {String}
   */ animationTimingFunc: "cubic-bezier(.165, .840, .440, 1)",
    /**
   * Wait for the animation to finish until the next user input can be processed
   *
   * @type {boolean}
   */ waitForTransition: true,
    /**
   * Throttle costly events at most once per every wait milliseconds.
   *
   * @type {Number}
   */ throttle: 10,
    /**
   * Moving direction mode.
   *
   * Available inputs:
   * - 'ltr' - left to right movement,
   * - 'rtl' - right to left movement.
   *
   * @type {String}
   */ direction: "ltr",
    /**
   * The distance value of the next and previous viewports which
   * have to peek in the current view. Accepts number and
   * pixels as a string. Left and right peeking can be
   * set up separately with a directions object.
   *
   * For example:
   * `100` - Peek 100px on the both sides.
   * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
   *
   * @type {Number|String|Object}
   */ peek: 0,
    /**
   * Defines how many clones of current viewport will be generated.
   *
   * @type {Number}
   */ cloningRatio: 1,
    /**
   * Collection of options applied at specified media breakpoints.
   * For example: display two slides per view under 800px.
   * `{
   *   '800px': {
   *     perView: 2
   *   }
   * }`
   */ breakpoints: {},
    /**
   * Collection of internally used HTML classes.
   *
   * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
   * @type {Object}
   */ classes: {
        swipeable: "glide--swipeable",
        dragging: "glide--dragging",
        direction: {
            ltr: "glide--ltr",
            rtl: "glide--rtl"
        },
        type: {
            slider: "glide--slider",
            carousel: "glide--carousel"
        },
        slide: {
            clone: "glide__slide--clone",
            active: "glide__slide--active"
        },
        arrow: {
            disabled: "glide__arrow--disabled"
        },
        nav: {
            active: "glide__bullet--active"
        }
    }
};
/**
 * Outputs warning message to the bowser console.
 *
 * @param  {String} msg
 * @return {Void}
 */ function $18c4610f4512b4f1$var$warn(msg) {
    console.error("[Glide warn]: ".concat(msg));
}
/**
 * Converts value entered as number
 * or string to integer value.
 *
 * @param {String} value
 * @returns {Number}
 */ function $18c4610f4512b4f1$var$toInt(value) {
    return parseInt(value);
}
/**
 * Converts value entered as number
 * or string to flat value.
 *
 * @param {String} value
 * @returns {Number}
 */ function $18c4610f4512b4f1$var$toFloat(value) {
    return parseFloat(value);
}
/**
 * Indicates whether the specified value is a string.
 *
 * @param  {*}   value
 * @return {Boolean}
 */ function $18c4610f4512b4f1$var$isString(value) {
    return typeof value === "string";
}
/**
 * Indicates whether the specified value is an object.
 *
 * @param  {*} value
 * @return {Boolean}
 *
 * @see https://github.com/jashkenas/underscore
 */ function $18c4610f4512b4f1$var$isObject(value) {
    var type = $18c4610f4512b4f1$var$_typeof(value);
    return type === "function" || type === "object" && !!value; // eslint-disable-line no-mixed-operators
}
/**
 * Indicates whether the specified value is a function.
 *
 * @param  {*} value
 * @return {Boolean}
 */ function $18c4610f4512b4f1$var$isFunction(value) {
    return typeof value === "function";
}
/**
 * Indicates whether the specified value is undefined.
 *
 * @param  {*} value
 * @return {Boolean}
 */ function $18c4610f4512b4f1$var$isUndefined(value) {
    return typeof value === "undefined";
}
/**
 * Indicates whether the specified value is an array.
 *
 * @param  {*} value
 * @return {Boolean}
 */ function $18c4610f4512b4f1$var$isArray(value) {
    return value.constructor === Array;
}
/**
 * Creates and initializes specified collection of extensions.
 * Each extension receives access to instance of glide and rest of components.
 *
 * @param {Object} glide
 * @param {Object} extensions
 *
 * @returns {Object}
 */ function $18c4610f4512b4f1$var$mount(glide, extensions, events) {
    var components = {};
    for(var name in extensions)if ($18c4610f4512b4f1$var$isFunction(extensions[name])) components[name] = extensions[name](glide, components, events);
    else $18c4610f4512b4f1$var$warn("Extension must be a function");
    for(var _name in components)if ($18c4610f4512b4f1$var$isFunction(components[_name].mount)) components[_name].mount();
    return components;
}
/**
 * Defines getter and setter property on the specified object.
 *
 * @param  {Object} obj         Object where property has to be defined.
 * @param  {String} prop        Name of the defined property.
 * @param  {Object} definition  Get and set definitions for the property.
 * @return {Void}
 */ function $18c4610f4512b4f1$var$define(obj, prop, definition) {
    Object.defineProperty(obj, prop, definition);
}
/**
 * Sorts aphabetically object keys.
 *
 * @param  {Object} obj
 * @return {Object}
 */ function $18c4610f4512b4f1$var$sortKeys(obj) {
    return Object.keys(obj).sort().reduce(function(r, k) {
        r[k] = obj[k];
        return r[k], r;
    }, {});
}
/**
 * Merges passed settings object with default options.
 *
 * @param  {Object} defaults
 * @param  {Object} settings
 * @return {Object}
 */ function $18c4610f4512b4f1$var$mergeOptions(defaults, settings) {
    var options = Object.assign({}, defaults, settings); // `Object.assign` do not deeply merge objects, so we
    // have to do it manually for every nested object
    // in options. Although it does not look smart,
    // it's smaller and faster than some fancy
    // merging deep-merge algorithm script.
    if (settings.hasOwnProperty("classes")) {
        options.classes = Object.assign({}, defaults.classes, settings.classes);
        if (settings.classes.hasOwnProperty("direction")) options.classes.direction = Object.assign({}, defaults.classes.direction, settings.classes.direction);
        if (settings.classes.hasOwnProperty("type")) options.classes.type = Object.assign({}, defaults.classes.type, settings.classes.type);
        if (settings.classes.hasOwnProperty("slide")) options.classes.slide = Object.assign({}, defaults.classes.slide, settings.classes.slide);
        if (settings.classes.hasOwnProperty("arrow")) options.classes.arrow = Object.assign({}, defaults.classes.arrow, settings.classes.arrow);
        if (settings.classes.hasOwnProperty("nav")) options.classes.nav = Object.assign({}, defaults.classes.nav, settings.classes.nav);
    }
    if (settings.hasOwnProperty("breakpoints")) options.breakpoints = Object.assign({}, defaults.breakpoints, settings.breakpoints);
    return options;
}
var $18c4610f4512b4f1$var$EventsBus = /*#__PURE__*/ function() {
    /**
   * Construct a EventBus instance.
   *
   * @param {Object} events
   */ function EventsBus() {
        var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $18c4610f4512b4f1$var$_classCallCheck(this, EventsBus);
        this.events = events;
        this.hop = events.hasOwnProperty;
    }
    /**
   * Adds listener to the specifed event.
   *
   * @param {String|Array} event
   * @param {Function} handler
   */ $18c4610f4512b4f1$var$_createClass(EventsBus, [
        {
            key: "on",
            value: function on(event, handler) {
                if ($18c4610f4512b4f1$var$isArray(event)) {
                    for(var i = 0; i < event.length; i++)this.on(event[i], handler);
                    return;
                } // Create the event's object if not yet created
                if (!this.hop.call(this.events, event)) this.events[event] = [];
                 // Add the handler to queue
                var index = this.events[event].push(handler) - 1; // Provide handle back for removal of event
                return {
                    remove: function remove() {
                        delete this.events[event][index];
                    }
                };
            }
        },
        {
            key: "emit",
            value: function emit(event, context) {
                if ($18c4610f4512b4f1$var$isArray(event)) {
                    for(var i = 0; i < event.length; i++)this.emit(event[i], context);
                    return;
                } // If the event doesn't exist, or there's no handlers in queue, just leave
                if (!this.hop.call(this.events, event)) return;
                 // Cycle through events queue, fire!
                this.events[event].forEach(function(item) {
                    item(context || {});
                });
            }
        }
    ]);
    return EventsBus;
}();
var $18c4610f4512b4f1$var$Glide$1 = /*#__PURE__*/ function() {
    /**
   * Construct glide.
   *
   * @param  {String} selector
   * @param  {Object} options
   */ function Glide(selector) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $18c4610f4512b4f1$var$_classCallCheck(this, Glide);
        this._c = {};
        this._t = [];
        this._e = new $18c4610f4512b4f1$var$EventsBus();
        this.disabled = false;
        this.selector = selector;
        this.settings = $18c4610f4512b4f1$var$mergeOptions($18c4610f4512b4f1$var$defaults, options);
        this.index = this.settings.startAt;
    }
    /**
   * Initializes glide.
   *
   * @param {Object} extensions Collection of extensions to initialize.
   * @return {Glide}
   */ $18c4610f4512b4f1$var$_createClass(Glide, [
        {
            key: "mount",
            value: function mount$1() {
                var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                this._e.emit("mount.before");
                if ($18c4610f4512b4f1$var$isObject(extensions)) this._c = $18c4610f4512b4f1$var$mount(this, extensions, this._e);
                else $18c4610f4512b4f1$var$warn("You need to provide a object on `mount()`");
                this._e.emit("mount.after");
                return this;
            }
        },
        {
            key: "mutate",
            value: function mutate() {
                var transformers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                if ($18c4610f4512b4f1$var$isArray(transformers)) this._t = transformers;
                else $18c4610f4512b4f1$var$warn("You need to provide a array on `mutate()`");
                return this;
            }
        },
        {
            key: "update",
            value: function update() {
                var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                this.settings = $18c4610f4512b4f1$var$mergeOptions(this.settings, settings);
                if (settings.hasOwnProperty("startAt")) this.index = settings.startAt;
                this._e.emit("update");
                return this;
            }
        },
        {
            key: "go",
            value: function go(pattern) {
                this._c.Run.make(pattern);
                return this;
            }
        },
        {
            key: "move",
            value: function move(distance) {
                this._c.Transition.disable();
                this._c.Move.make(distance);
                return this;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this._e.emit("destroy");
                return this;
            }
        },
        {
            key: "play",
            value: function play() {
                var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                if (interval) this.settings.autoplay = interval;
                this._e.emit("play");
                return this;
            }
        },
        {
            key: "pause",
            value: function pause() {
                this._e.emit("pause");
                return this;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.disabled = true;
                return this;
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.disabled = false;
                return this;
            }
        },
        {
            key: "on",
            value: function on(event, handler) {
                this._e.on(event, handler);
                return this;
            }
        },
        {
            key: "isType",
            value: function isType(name) {
                return this.settings.type === name;
            }
        },
        {
            key: "settings",
            get: function get() {
                return this._o;
            },
            set: function set(o) {
                if ($18c4610f4512b4f1$var$isObject(o)) this._o = o;
                else $18c4610f4512b4f1$var$warn("Options must be an `object` instance.");
            }
        },
        {
            key: "index",
            get: function get() {
                return this._i;
            },
            set: function set(i) {
                this._i = $18c4610f4512b4f1$var$toInt(i);
            }
        },
        {
            key: "type",
            get: function get() {
                return this.settings.type;
            }
        },
        {
            key: "disabled",
            get: function get() {
                return this._d;
            },
            set: function set(status) {
                this._d = !!status;
            }
        }
    ]);
    return Glide;
}();
function $18c4610f4512b4f1$var$Run(Glide, Components, Events) {
    var Run = {
        /**
     * Initializes autorunning of the glide.
     *
     * @return {Void}
     */ mount: function mount() {
            this._o = false;
        },
        /**
     * Makes glides running based on the passed moving schema.
     *
     * @param {String} move
     */ make: function make(move) {
            var _this = this;
            if (!Glide.disabled) {
                !Glide.settings.waitForTransition || Glide.disable();
                this.move = move;
                Events.emit("run.before", this.move);
                this.calculate();
                Events.emit("run", this.move);
                Components.Transition.after(function() {
                    if (_this.isStart()) Events.emit("run.start", _this.move);
                    if (_this.isEnd()) Events.emit("run.end", _this.move);
                    if (_this.isOffset()) {
                        _this._o = false;
                        Events.emit("run.offset", _this.move);
                    }
                    Events.emit("run.after", _this.move);
                    Glide.enable();
                });
            }
        },
        /**
     * Calculates current index based on defined move.
     *
     * @return {Number|Undefined}
     */ calculate: function calculate() {
            var move = this.move, length = this.length;
            var steps = move.steps, direction = move.direction; // By default assume that size of view is equal to one slide
            var viewSize = 1; // While direction is `=` we want jump to
            // a specified index described in steps.
            if (direction === "=") {
                // Check if bound is true, 
                // as we want to avoid whitespaces.
                if (Glide.settings.bound && $18c4610f4512b4f1$var$toInt(steps) > length) {
                    Glide.index = length;
                    return;
                }
                Glide.index = steps;
                return;
            } // When pattern is equal to `>>` we want
            // fast forward to the last slide.
            if (direction === ">" && steps === ">") {
                Glide.index = length;
                return;
            } // When pattern is equal to `<<` we want
            // fast forward to the first slide.
            if (direction === "<" && steps === "<") {
                Glide.index = 0;
                return;
            } // pagination movement
            if (direction === "|") viewSize = Glide.settings.perView || 1;
             // we are moving forward
            if (direction === ">" || direction === "|" && steps === ">") {
                var index = calculateForwardIndex(viewSize);
                if (index > length) this._o = true;
                Glide.index = normalizeForwardIndex(index, viewSize);
                return;
            } // we are moving backward
            if (direction === "<" || direction === "|" && steps === "<") {
                var _index = calculateBackwardIndex(viewSize);
                if (_index < 0) this._o = true;
                Glide.index = normalizeBackwardIndex(_index, viewSize);
                return;
            }
            $18c4610f4512b4f1$var$warn("Invalid direction pattern [".concat(direction).concat(steps, "] has been used"));
        },
        /**
     * Checks if we are on the first slide.
     *
     * @return {Boolean}
     */ isStart: function isStart() {
            return Glide.index <= 0;
        },
        /**
     * Checks if we are on the last slide.
     *
     * @return {Boolean}
     */ isEnd: function isEnd() {
            return Glide.index >= this.length;
        },
        /**
     * Checks if we are making a offset run.
     *
     * @param {String} direction
     * @return {Boolean}
     */ isOffset: function isOffset() {
            var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            if (!direction) return this._o;
            if (!this._o) return false;
             // did we view to the right?
            if (direction === "|>") return this.move.direction === "|" && this.move.steps === ">";
             // did we view to the left?
            if (direction === "|<") return this.move.direction === "|" && this.move.steps === "<";
            return this.move.direction === direction;
        },
        /**
     * Checks if bound mode is active
     *
     * @return {Boolean}
     */ isBound: function isBound() {
            return Glide.isType("slider") && Glide.settings.focusAt !== "center" && Glide.settings.bound;
        }
    };
    /**
   * Returns index value to move forward/to the right
   *
   * @param viewSize
   * @returns {Number}
   */ function calculateForwardIndex(viewSize) {
        var index = Glide.index;
        if (Glide.isType("carousel")) return index + viewSize;
        return index + (viewSize - index % viewSize);
    }
    /**
   * Normalizes the given forward index based on glide settings, preventing it to exceed certain boundaries
   *
   * @param index
   * @param length
   * @param viewSize
   * @returns {Number}
   */ function normalizeForwardIndex(index, viewSize) {
        var length = Run.length;
        if (index <= length) return index;
        if (Glide.isType("carousel")) return index - (length + 1);
        if (Glide.settings.rewind) {
            // bound does funny things with the length, therefor we have to be certain
            // that we are on the last possible index value given by bound
            if (Run.isBound() && !Run.isEnd()) return length;
            return 0;
        }
        if (Run.isBound()) return length;
        return Math.floor(length / viewSize) * viewSize;
    }
    /**
   * Calculates index value to move backward/to the left
   *
   * @param viewSize
   * @returns {Number}
   */ function calculateBackwardIndex(viewSize) {
        var index = Glide.index;
        if (Glide.isType("carousel")) return index - viewSize;
         // ensure our back navigation results in the same index as a forward navigation
        // to experience a homogeneous paging
        var view = Math.ceil(index / viewSize);
        return (view - 1) * viewSize;
    }
    /**
   * Normalizes the given backward index based on glide settings, preventing it to exceed certain boundaries
   *
   * @param index
   * @param length
   * @param viewSize
   * @returns {*}
   */ function normalizeBackwardIndex(index, viewSize) {
        var length = Run.length;
        if (index >= 0) return index;
        if (Glide.isType("carousel")) return index + (length + 1);
        if (Glide.settings.rewind) {
            // bound does funny things with the length, therefor we have to be certain
            // that we are on first possible index value before we to rewind to the length given by bound
            if (Run.isBound() && Run.isStart()) return length;
            return Math.floor(length / viewSize) * viewSize;
        }
        return 0;
    }
    $18c4610f4512b4f1$var$define(Run, "move", {
        /**
     * Gets value of the move schema.
     *
     * @returns {Object}
     */ get: function get() {
            return this._m;
        },
        /**
     * Sets value of the move schema.
     *
     * @returns {Object}
     */ set: function set(value) {
            var step = value.substr(1);
            this._m = {
                direction: value.substr(0, 1),
                steps: step ? $18c4610f4512b4f1$var$toInt(step) ? $18c4610f4512b4f1$var$toInt(step) : step : 0
            };
        }
    });
    $18c4610f4512b4f1$var$define(Run, "length", {
        /**
     * Gets value of the running distance based
     * on zero-indexing number of slides.
     *
     * @return {Number}
     */ get: function get() {
            var settings = Glide.settings;
            var length = Components.Html.slides.length; // If the `bound` option is active, a maximum running distance should be
            // reduced by `perView` and `focusAt` settings. Running distance
            // should end before creating an empty space after instance.
            if (this.isBound()) return length - 1 - ($18c4610f4512b4f1$var$toInt(settings.perView) - 1) + $18c4610f4512b4f1$var$toInt(settings.focusAt);
            return length - 1;
        }
    });
    $18c4610f4512b4f1$var$define(Run, "offset", {
        /**
     * Gets status of the offsetting flag.
     *
     * @return {Boolean}
     */ get: function get() {
            return this._o;
        }
    });
    return Run;
}
/**
 * Returns a current time.
 *
 * @return {Number}
 */ function $18c4610f4512b4f1$var$now() {
    return new Date().getTime();
}
/**
 * Returns a function, that, when invoked, will only be triggered
 * at most once during a given window of time.
 *
 * @param {Function} func
 * @param {Number} wait
 * @param {Object=} options
 * @return {Function}
 *
 * @see https://github.com/jashkenas/underscore
 */ function $18c4610f4512b4f1$var$throttle(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};
    var later = function later() {
        previous = options.leading === false ? 0 : $18c4610f4512b4f1$var$now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    var throttled = function throttled() {
        var at = $18c4610f4512b4f1$var$now();
        if (!previous && options.leading === false) previous = at;
        var remaining = wait - (at - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = at;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
    throttled.cancel = function() {
        clearTimeout(timeout);
        previous = 0;
        timeout = context = args = null;
    };
    return throttled;
}
var $18c4610f4512b4f1$var$MARGIN_TYPE = {
    ltr: [
        "marginLeft",
        "marginRight"
    ],
    rtl: [
        "marginRight",
        "marginLeft"
    ]
};
function $18c4610f4512b4f1$var$Gaps(Glide, Components, Events) {
    var Gaps = {
        /**
     * Applies gaps between slides. First and last
     * slides do not receive it's edge margins.
     *
     * @param {HTMLCollection} slides
     * @return {Void}
     */ apply: function apply(slides) {
            for(var i = 0, len = slides.length; i < len; i++){
                var style = slides[i].style;
                var direction = Components.Direction.value;
                if (i !== 0) style[$18c4610f4512b4f1$var$MARGIN_TYPE[direction][0]] = "".concat(this.value / 2, "px");
                else style[$18c4610f4512b4f1$var$MARGIN_TYPE[direction][0]] = "";
                if (i !== slides.length - 1) style[$18c4610f4512b4f1$var$MARGIN_TYPE[direction][1]] = "".concat(this.value / 2, "px");
                else style[$18c4610f4512b4f1$var$MARGIN_TYPE[direction][1]] = "";
            }
        },
        /**
     * Removes gaps from the slides.
     *
     * @param {HTMLCollection} slides
     * @returns {Void}
    */ remove: function remove(slides) {
            for(var i = 0, len = slides.length; i < len; i++){
                var style = slides[i].style;
                style.marginLeft = "";
                style.marginRight = "";
            }
        }
    };
    $18c4610f4512b4f1$var$define(Gaps, "value", {
        /**
     * Gets value of the gap.
     *
     * @returns {Number}
     */ get: function get() {
            return $18c4610f4512b4f1$var$toInt(Glide.settings.gap);
        }
    });
    $18c4610f4512b4f1$var$define(Gaps, "grow", {
        /**
     * Gets additional dimensions value caused by gaps.
     * Used to increase width of the slides wrapper.
     *
     * @returns {Number}
     */ get: function get() {
            return Gaps.value * Components.Sizes.length;
        }
    });
    $18c4610f4512b4f1$var$define(Gaps, "reductor", {
        /**
     * Gets reduction value caused by gaps.
     * Used to subtract width of the slides.
     *
     * @returns {Number}
     */ get: function get() {
            var perView = Glide.settings.perView;
            return Gaps.value * (perView - 1) / perView;
        }
    });
    /**
   * Apply calculated gaps:
   * - after building, so slides (including clones) will receive proper margins
   * - on updating via API, to recalculate gaps with new options
   */ Events.on([
        "build.after",
        "update"
    ], $18c4610f4512b4f1$var$throttle(function() {
        Gaps.apply(Components.Html.wrapper.children);
    }, 30));
    /**
   * Remove gaps:
   * - on destroying to bring markup to its inital state
   */ Events.on("destroy", function() {
        Gaps.remove(Components.Html.wrapper.children);
    });
    return Gaps;
}
/**
 * Finds siblings nodes of the passed node.
 *
 * @param  {Element} node
 * @return {Array}
 */ function $18c4610f4512b4f1$var$siblings(node) {
    if (node && node.parentNode) {
        var n = node.parentNode.firstChild;
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== node) matched.push(n);
        return matched;
    }
    return [];
}
/**
 * Checks if passed node exist and is a valid element.
 *
 * @param  {Element} node
 * @return {Boolean}
 */ function $18c4610f4512b4f1$var$exist(node) {
    if (node && node instanceof window.HTMLElement) return true;
    return false;
}
/**
 * Coerces a NodeList to an Array.
 *
 * @param  {NodeList} nodeList
 * @return {Array}
 */ function $18c4610f4512b4f1$var$toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
}
var $18c4610f4512b4f1$var$TRACK_SELECTOR = '[data-glide-el="track"]';
function $18c4610f4512b4f1$var$Html(Glide, Components, Events) {
    var Html = {
        /**
     * Setup slider HTML nodes.
     *
     * @param {Glide} glide
     */ mount: function mount() {
            this.root = Glide.selector;
            this.track = this.root.querySelector($18c4610f4512b4f1$var$TRACK_SELECTOR);
            this.collectSlides();
        },
        /**
     * Collect slides
     */ collectSlides: function collectSlides() {
            this.slides = $18c4610f4512b4f1$var$toArray(this.wrapper.children).filter(function(slide) {
                return !slide.classList.contains(Glide.settings.classes.slide.clone);
            });
        }
    };
    $18c4610f4512b4f1$var$define(Html, "root", {
        /**
     * Gets node of the glide main element.
     *
     * @return {Object}
     */ get: function get() {
            return Html._r;
        },
        /**
     * Sets node of the glide main element.
     *
     * @return {Object}
     */ set: function set(r) {
            if ($18c4610f4512b4f1$var$isString(r)) r = document.querySelector(r);
            if ($18c4610f4512b4f1$var$exist(r)) Html._r = r;
            else $18c4610f4512b4f1$var$warn("Root element must be a existing Html node");
        }
    });
    $18c4610f4512b4f1$var$define(Html, "track", {
        /**
     * Gets node of the glide track with slides.
     *
     * @return {Object}
     */ get: function get() {
            return Html._t;
        },
        /**
     * Sets node of the glide track with slides.
     *
     * @return {Object}
     */ set: function set(t) {
            if ($18c4610f4512b4f1$var$exist(t)) Html._t = t;
            else $18c4610f4512b4f1$var$warn("Could not find track element. Please use ".concat($18c4610f4512b4f1$var$TRACK_SELECTOR, " attribute."));
        }
    });
    $18c4610f4512b4f1$var$define(Html, "wrapper", {
        /**
     * Gets node of the slides wrapper.
     *
     * @return {Object}
     */ get: function get() {
            return Html.track.children[0];
        }
    });
    /**
   * Add/remove/reorder dynamic slides
   */ Events.on("update", function() {
        Html.collectSlides();
    });
    return Html;
}
function $18c4610f4512b4f1$var$Peek(Glide, Components, Events) {
    var Peek = {
        /**
     * Setups how much to peek based on settings.
     *
     * @return {Void}
     */ mount: function mount() {
            this.value = Glide.settings.peek;
        }
    };
    $18c4610f4512b4f1$var$define(Peek, "value", {
        /**
     * Gets value of the peek.
     *
     * @returns {Number|Object}
     */ get: function get() {
            return Peek._v;
        },
        /**
     * Sets value of the peek.
     *
     * @param {Number|Object} value
     * @return {Void}
     */ set: function set(value) {
            if ($18c4610f4512b4f1$var$isObject(value)) {
                value.before = $18c4610f4512b4f1$var$toInt(value.before);
                value.after = $18c4610f4512b4f1$var$toInt(value.after);
            } else value = $18c4610f4512b4f1$var$toInt(value);
            Peek._v = value;
        }
    });
    $18c4610f4512b4f1$var$define(Peek, "reductor", {
        /**
     * Gets reduction value caused by peek.
     *
     * @returns {Number}
     */ get: function get() {
            var value = Peek.value;
            var perView = Glide.settings.perView;
            if ($18c4610f4512b4f1$var$isObject(value)) return value.before / perView + value.after / perView;
            return value * 2 / perView;
        }
    });
    /**
   * Recalculate peeking sizes on:
   * - when resizing window to update to proper percents
   */ Events.on([
        "resize",
        "update"
    ], function() {
        Peek.mount();
    });
    return Peek;
}
function $18c4610f4512b4f1$var$Move(Glide, Components, Events) {
    var Move = {
        /**
     * Constructs move component.
     *
     * @returns {Void}
     */ mount: function mount() {
            this._o = 0;
        },
        /**
     * Calculates a movement value based on passed offset and currently active index.
     *
     * @param  {Number} offset
     * @return {Void}
     */ make: function make() {
            var _this = this;
            var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            this.offset = offset;
            Events.emit("move", {
                movement: this.value
            });
            Components.Transition.after(function() {
                Events.emit("move.after", {
                    movement: _this.value
                });
            });
        }
    };
    $18c4610f4512b4f1$var$define(Move, "offset", {
        /**
     * Gets an offset value used to modify current translate.
     *
     * @return {Object}
     */ get: function get() {
            return Move._o;
        },
        /**
     * Sets an offset value used to modify current translate.
     *
     * @return {Object}
     */ set: function set(value) {
            Move._o = !$18c4610f4512b4f1$var$isUndefined(value) ? $18c4610f4512b4f1$var$toInt(value) : 0;
        }
    });
    $18c4610f4512b4f1$var$define(Move, "translate", {
        /**
     * Gets a raw movement value.
     *
     * @return {Number}
     */ get: function get() {
            return Components.Sizes.slideWidth * Glide.index;
        }
    });
    $18c4610f4512b4f1$var$define(Move, "value", {
        /**
     * Gets an actual movement value corrected by offset.
     *
     * @return {Number}
     */ get: function get() {
            var offset = this.offset;
            var translate = this.translate;
            if (Components.Direction.is("rtl")) return translate + offset;
            return translate - offset;
        }
    });
    /**
   * Make movement to proper slide on:
   * - before build, so glide will start at `startAt` index
   * - on each standard run to move to newly calculated index
   */ Events.on([
        "build.before",
        "run"
    ], function() {
        Move.make();
    });
    return Move;
}
function $18c4610f4512b4f1$var$Sizes(Glide, Components, Events) {
    var Sizes = {
        /**
     * Setups dimensions of slides.
     *
     * @return {Void}
     */ setupSlides: function setupSlides() {
            var width = "".concat(this.slideWidth, "px");
            var slides = Components.Html.slides;
            for(var i = 0; i < slides.length; i++)slides[i].style.width = width;
        },
        /**
     * Setups dimensions of slides wrapper.
     *
     * @return {Void}
     */ setupWrapper: function setupWrapper() {
            Components.Html.wrapper.style.width = "".concat(this.wrapperSize, "px");
        },
        /**
     * Removes applied styles from HTML elements.
     *
     * @returns {Void}
     */ remove: function remove() {
            var slides = Components.Html.slides;
            for(var i = 0; i < slides.length; i++)slides[i].style.width = "";
            Components.Html.wrapper.style.width = "";
        }
    };
    $18c4610f4512b4f1$var$define(Sizes, "length", {
        /**
     * Gets count number of the slides.
     *
     * @return {Number}
     */ get: function get() {
            return Components.Html.slides.length;
        }
    });
    $18c4610f4512b4f1$var$define(Sizes, "width", {
        /**
     * Gets width value of the slider (visible area).
     *
     * @return {Number}
     */ get: function get() {
            return Components.Html.track.offsetWidth;
        }
    });
    $18c4610f4512b4f1$var$define(Sizes, "wrapperSize", {
        /**
     * Gets size of the slides wrapper.
     *
     * @return {Number}
     */ get: function get() {
            return Sizes.slideWidth * Sizes.length + Components.Gaps.grow + Components.Clones.grow;
        }
    });
    $18c4610f4512b4f1$var$define(Sizes, "slideWidth", {
        /**
     * Gets width value of a single slide.
     *
     * @return {Number}
     */ get: function get() {
            return Sizes.width / Glide.settings.perView - Components.Peek.reductor - Components.Gaps.reductor;
        }
    });
    /**
   * Apply calculated glide's dimensions:
   * - before building, so other dimensions (e.g. translate) will be calculated propertly
   * - when resizing window to recalculate sildes dimensions
   * - on updating via API, to calculate dimensions based on new options
   */ Events.on([
        "build.before",
        "resize",
        "update"
    ], function() {
        Sizes.setupSlides();
        Sizes.setupWrapper();
    });
    /**
   * Remove calculated glide's dimensions:
   * - on destoting to bring markup to its inital state
   */ Events.on("destroy", function() {
        Sizes.remove();
    });
    return Sizes;
}
function $18c4610f4512b4f1$var$Build(Glide, Components, Events) {
    var Build = {
        /**
     * Init glide building. Adds classes, sets
     * dimensions and setups initial state.
     *
     * @return {Void}
     */ mount: function mount() {
            Events.emit("build.before");
            this.typeClass();
            this.activeClass();
            Events.emit("build.after");
        },
        /**
     * Adds `type` class to the glide element.
     *
     * @return {Void}
     */ typeClass: function typeClass() {
            Components.Html.root.classList.add(Glide.settings.classes.type[Glide.settings.type]);
        },
        /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */ activeClass: function activeClass() {
            var classes = Glide.settings.classes;
            var slide = Components.Html.slides[Glide.index];
            if (slide) {
                slide.classList.add(classes.slide.active);
                $18c4610f4512b4f1$var$siblings(slide).forEach(function(sibling) {
                    sibling.classList.remove(classes.slide.active);
                });
            }
        },
        /**
     * Removes HTML classes applied at building.
     *
     * @return {Void}
     */ removeClasses: function removeClasses() {
            var _Glide$settings$class = Glide.settings.classes, type = _Glide$settings$class.type, slide = _Glide$settings$class.slide;
            Components.Html.root.classList.remove(type[Glide.settings.type]);
            Components.Html.slides.forEach(function(sibling) {
                sibling.classList.remove(slide.active);
            });
        }
    };
    /**
   * Clear building classes:
   * - on destroying to bring HTML to its initial state
   * - on updating to remove classes before remounting component
   */ Events.on([
        "destroy",
        "update"
    ], function() {
        Build.removeClasses();
    });
    /**
   * Remount component:
   * - on resizing of the window to calculate new dimensions
   * - on updating settings via API
   */ Events.on([
        "resize",
        "update"
    ], function() {
        Build.mount();
    });
    /**
   * Swap active class of current slide:
   * - after each move to the new index
   */ Events.on("move.after", function() {
        Build.activeClass();
    });
    return Build;
}
function $18c4610f4512b4f1$var$Clones(Glide, Components, Events) {
    var Clones = {
        /**
     * Create pattern map and collect slides to be cloned.
     */ mount: function mount() {
            this.items = [];
            if (Glide.isType("carousel")) this.items = this.collect();
        },
        /**
     * Collect clones with pattern.
     *
     * @return {[]}
     */ collect: function collect() {
            var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var slides = Components.Html.slides;
            var _Glide$settings = Glide.settings, perView = _Glide$settings.perView, classes = _Glide$settings.classes, cloningRatio = _Glide$settings.cloningRatio;
            if (slides.length !== 0) {
                var peekIncrementer = +!!Glide.settings.peek;
                var cloneCount = perView + peekIncrementer + Math.round(perView / 2);
                var append = slides.slice(0, cloneCount).reverse();
                var prepend = slides.slice(cloneCount * -1);
                for(var r = 0; r < Math.max(cloningRatio, Math.floor(perView / slides.length)); r++){
                    for(var i = 0; i < append.length; i++){
                        var clone = append[i].cloneNode(true);
                        clone.classList.add(classes.slide.clone);
                        items.push(clone);
                    }
                    for(var _i = 0; _i < prepend.length; _i++){
                        var _clone = prepend[_i].cloneNode(true);
                        _clone.classList.add(classes.slide.clone);
                        items.unshift(_clone);
                    }
                }
            }
            return items;
        },
        /**
     * Append cloned slides with generated pattern.
     *
     * @return {Void}
     */ append: function append() {
            var items = this.items;
            var _Components$Html = Components.Html, wrapper = _Components$Html.wrapper, slides = _Components$Html.slides;
            var half = Math.floor(items.length / 2);
            var prepend = items.slice(0, half).reverse();
            var append = items.slice(half * -1).reverse();
            var width = "".concat(Components.Sizes.slideWidth, "px");
            for(var i = 0; i < append.length; i++)wrapper.appendChild(append[i]);
            for(var _i2 = 0; _i2 < prepend.length; _i2++)wrapper.insertBefore(prepend[_i2], slides[0]);
            for(var _i3 = 0; _i3 < items.length; _i3++)items[_i3].style.width = width;
        },
        /**
     * Remove all cloned slides.
     *
     * @return {Void}
     */ remove: function remove() {
            var items = this.items;
            for(var i = 0; i < items.length; i++)Components.Html.wrapper.removeChild(items[i]);
        }
    };
    $18c4610f4512b4f1$var$define(Clones, "grow", {
        /**
     * Gets additional dimensions value caused by clones.
     *
     * @return {Number}
     */ get: function get() {
            return (Components.Sizes.slideWidth + Components.Gaps.value) * Clones.items.length;
        }
    });
    /**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */ Events.on("update", function() {
        Clones.remove();
        Clones.mount();
        Clones.append();
    });
    /**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */ Events.on("build.before", function() {
        if (Glide.isType("carousel")) Clones.append();
    });
    /**
   * Remove clones HTMLElements:
   * - on destroying, to bring HTML to its initial state
   */ Events.on("destroy", function() {
        Clones.remove();
    });
    return Clones;
}
var $18c4610f4512b4f1$var$EventsBinder = /*#__PURE__*/ function() {
    /**
   * Construct a EventsBinder instance.
   */ function EventsBinder() {
        var listeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $18c4610f4512b4f1$var$_classCallCheck(this, EventsBinder);
        this.listeners = listeners;
    }
    /**
   * Adds events listeners to arrows HTML elements.
   *
   * @param  {String|Array} events
   * @param  {Element|Window|Document} el
   * @param  {Function} closure
   * @param  {Boolean|Object} capture
   * @return {Void}
   */ $18c4610f4512b4f1$var$_createClass(EventsBinder, [
        {
            key: "on",
            value: function on(events, el, closure) {
                var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                if ($18c4610f4512b4f1$var$isString(events)) events = [
                    events
                ];
                for(var i = 0; i < events.length; i++){
                    this.listeners[events[i]] = closure;
                    el.addEventListener(events[i], this.listeners[events[i]], capture);
                }
            }
        },
        {
            key: "off",
            value: function off(events, el) {
                var capture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                if ($18c4610f4512b4f1$var$isString(events)) events = [
                    events
                ];
                for(var i = 0; i < events.length; i++)el.removeEventListener(events[i], this.listeners[events[i]], capture);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                delete this.listeners;
            }
        }
    ]);
    return EventsBinder;
}();
function $18c4610f4512b4f1$var$Resize(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $18c4610f4512b4f1$var$EventsBinder();
    var Resize = {
        /**
     * Initializes window bindings.
     */ mount: function mount() {
            this.bind();
        },
        /**
     * Binds `rezsize` listener to the window.
     * It's a costly event, so we are debouncing it.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on("resize", window, $18c4610f4512b4f1$var$throttle(function() {
                Events.emit("resize");
            }, Glide.settings.throttle));
        },
        /**
     * Unbinds listeners from the window.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off("resize", window);
        }
    };
    /**
   * Remove bindings from window:
   * - on destroying, to remove added EventListener
   */ Events.on("destroy", function() {
        Resize.unbind();
        Binder.destroy();
    });
    return Resize;
}
var $18c4610f4512b4f1$var$VALID_DIRECTIONS = [
    "ltr",
    "rtl"
];
var $18c4610f4512b4f1$var$FLIPED_MOVEMENTS = {
    ">": "<",
    "<": ">",
    "=": "="
};
function $18c4610f4512b4f1$var$Direction(Glide, Components, Events) {
    var Direction = {
        /**
     * Setups gap value based on settings.
     *
     * @return {Void}
     */ mount: function mount() {
            this.value = Glide.settings.direction;
        },
        /**
     * Resolves pattern based on direction value
     *
     * @param {String} pattern
     * @returns {String}
     */ resolve: function resolve(pattern) {
            var token = pattern.slice(0, 1);
            if (this.is("rtl")) return pattern.split(token).join($18c4610f4512b4f1$var$FLIPED_MOVEMENTS[token]);
            return pattern;
        },
        /**
     * Checks value of direction mode.
     *
     * @param {String} direction
     * @returns {Boolean}
     */ is: function is(direction) {
            return this.value === direction;
        },
        /**
     * Applies direction class to the root HTML element.
     *
     * @return {Void}
     */ addClass: function addClass() {
            Components.Html.root.classList.add(Glide.settings.classes.direction[this.value]);
        },
        /**
     * Removes direction class from the root HTML element.
     *
     * @return {Void}
     */ removeClass: function removeClass() {
            Components.Html.root.classList.remove(Glide.settings.classes.direction[this.value]);
        }
    };
    $18c4610f4512b4f1$var$define(Direction, "value", {
        /**
     * Gets value of the direction.
     *
     * @returns {Number}
     */ get: function get() {
            return Direction._v;
        },
        /**
     * Sets value of the direction.
     *
     * @param {String} value
     * @return {Void}
     */ set: function set(value) {
            if ($18c4610f4512b4f1$var$VALID_DIRECTIONS.indexOf(value) > -1) Direction._v = value;
            else $18c4610f4512b4f1$var$warn("Direction value must be `ltr` or `rtl`");
        }
    });
    /**
   * Clear direction class:
   * - on destroy to bring HTML to its initial state
   * - on update to remove class before reappling bellow
   */ Events.on([
        "destroy",
        "update"
    ], function() {
        Direction.removeClass();
    });
    /**
   * Remount component:
   * - on update to reflect changes in direction value
   */ Events.on("update", function() {
        Direction.mount();
    });
    /**
   * Apply direction class:
   * - before building to apply class for the first time
   * - on updating to reapply direction class that may changed
   */ Events.on([
        "build.before",
        "update"
    ], function() {
        Direction.addClass();
    });
    return Direction;
}
/**
 * Reflects value of glide movement.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $18c4610f4512b4f1$var$Rtl(Glide, Components) {
    return {
        /**
     * Negates the passed translate if glide is in RTL option.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            if (Components.Direction.is("rtl")) return -translate;
            return translate;
        }
    };
}
/**
 * Updates glide movement with a `gap` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $18c4610f4512b4f1$var$Gap(Glide, Components) {
    return {
        /**
     * Modifies passed translate value with number in the `gap` settings.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            var multiplier = Math.floor(translate / Components.Sizes.slideWidth);
            return translate + Components.Gaps.value * multiplier;
        }
    };
}
/**
 * Updates glide movement with width of additional clones width.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $18c4610f4512b4f1$var$Grow(Glide, Components) {
    return {
        /**
     * Adds to the passed translate width of the half of clones.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            return translate + Components.Clones.grow / 2;
        }
    };
}
/**
 * Updates glide movement with a `peek` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $18c4610f4512b4f1$var$Peeking(Glide, Components) {
    return {
        /**
     * Modifies passed translate value with a `peek` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            if (Glide.settings.focusAt >= 0) {
                var peek = Components.Peek.value;
                if ($18c4610f4512b4f1$var$isObject(peek)) return translate - peek.before;
                return translate - peek;
            }
            return translate;
        }
    };
}
/**
 * Updates glide movement with a `focusAt` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $18c4610f4512b4f1$var$Focusing(Glide, Components) {
    return {
        /**
     * Modifies passed translate value with index in the `focusAt` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            var gap = Components.Gaps.value;
            var width = Components.Sizes.width;
            var focusAt = Glide.settings.focusAt;
            var slideWidth = Components.Sizes.slideWidth;
            if (focusAt === "center") return translate - (width / 2 - slideWidth / 2);
            return translate - slideWidth * focusAt - gap * focusAt;
        }
    };
}
/**
 * Applies diffrent transformers on translate value.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $18c4610f4512b4f1$var$mutator(Glide, Components, Events) {
    /**
   * Merge instance transformers with collection of default transformers.
   * It's important that the Rtl component be last on the list,
   * so it reflects all previous transformations.
   *
   * @type {Array}
   */ var TRANSFORMERS = [
        $18c4610f4512b4f1$var$Gap,
        $18c4610f4512b4f1$var$Grow,
        $18c4610f4512b4f1$var$Peeking,
        $18c4610f4512b4f1$var$Focusing
    ].concat(Glide._t, [
        $18c4610f4512b4f1$var$Rtl
    ]);
    return {
        /**
     * Piplines translate value with registered transformers.
     *
     * @param  {Number} translate
     * @return {Number}
     */ mutate: function mutate(translate) {
            for(var i = 0; i < TRANSFORMERS.length; i++){
                var transformer = TRANSFORMERS[i];
                if ($18c4610f4512b4f1$var$isFunction(transformer) && $18c4610f4512b4f1$var$isFunction(transformer().modify)) translate = transformer(Glide, Components, Events).modify(translate);
                else $18c4610f4512b4f1$var$warn("Transformer should be a function that returns an object with `modify()` method");
            }
            return translate;
        }
    };
}
function $18c4610f4512b4f1$var$Translate(Glide, Components, Events) {
    var Translate = {
        /**
     * Sets value of translate on HTML element.
     *
     * @param {Number} value
     * @return {Void}
     */ set: function set(value) {
            var transform = $18c4610f4512b4f1$var$mutator(Glide, Components).mutate(value);
            var translate3d = "translate3d(".concat(-1 * transform, "px, 0px, 0px)");
            Components.Html.wrapper.style.mozTransform = translate3d; // needed for supported Firefox 10-15
            Components.Html.wrapper.style.webkitTransform = translate3d; // needed for supported Chrome 10-35, Safari 5.1-8, and Opera 15-22
            Components.Html.wrapper.style.transform = translate3d;
        },
        /**
     * Removes value of translate from HTML element.
     *
     * @return {Void}
     */ remove: function remove() {
            Components.Html.wrapper.style.transform = "";
        },
        /**
     * @return {number}
     */ getStartIndex: function getStartIndex() {
            var length = Components.Sizes.length;
            var index = Glide.index;
            var perView = Glide.settings.perView;
            if (Components.Run.isOffset(">") || Components.Run.isOffset("|>")) return length + (index - perView);
             // "modulo length" converts an index that equals length to zero
            return (index + perView) % length;
        },
        /**
     * @return {number}
     */ getTravelDistance: function getTravelDistance() {
            var travelDistance = Components.Sizes.slideWidth * Glide.settings.perView;
            if (Components.Run.isOffset(">") || Components.Run.isOffset("|>")) // reverse travel distance so that we don't have to change subtract operations
            return travelDistance * -1;
            return travelDistance;
        }
    };
    /**
   * Set new translate value:
   * - on move to reflect index change
   * - on updating via API to reflect possible changes in options
   */ Events.on("move", function(context) {
        if (!Glide.isType("carousel") || !Components.Run.isOffset()) return Translate.set(context.movement);
        Components.Transition.after(function() {
            Events.emit("translate.jump");
            Translate.set(Components.Sizes.slideWidth * Glide.index);
        });
        var startWidth = Components.Sizes.slideWidth * Components.Translate.getStartIndex();
        return Translate.set(startWidth - Components.Translate.getTravelDistance());
    });
    /**
   * Remove translate:
   * - on destroying to bring markup to its inital state
   */ Events.on("destroy", function() {
        Translate.remove();
    });
    return Translate;
}
function $18c4610f4512b4f1$var$Transition(Glide, Components, Events) {
    /**
   * Holds inactivity status of transition.
   * When true transition is not applied.
   *
   * @type {Boolean}
   */ var disabled = false;
    var Transition = {
        /**
     * Composes string of the CSS transition.
     *
     * @param {String} property
     * @return {String}
     */ compose: function compose(property) {
            var settings = Glide.settings;
            if (!disabled) return "".concat(property, " ").concat(this.duration, "ms ").concat(settings.animationTimingFunc);
            return "".concat(property, " 0ms ").concat(settings.animationTimingFunc);
        },
        /**
     * Sets value of transition on HTML element.
     *
     * @param {String=} property
     * @return {Void}
     */ set: function set() {
            var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "transform";
            Components.Html.wrapper.style.transition = this.compose(property);
        },
        /**
     * Removes value of transition from HTML element.
     *
     * @return {Void}
     */ remove: function remove() {
            Components.Html.wrapper.style.transition = "";
        },
        /**
     * Runs callback after animation.
     *
     * @param  {Function} callback
     * @return {Void}
     */ after: function after(callback) {
            setTimeout(function() {
                callback();
            }, this.duration);
        },
        /**
     * Enable transition.
     *
     * @return {Void}
     */ enable: function enable() {
            disabled = false;
            this.set();
        },
        /**
     * Disable transition.
     *
     * @return {Void}
     */ disable: function disable() {
            disabled = true;
            this.set();
        }
    };
    $18c4610f4512b4f1$var$define(Transition, "duration", {
        /**
     * Gets duration of the transition based
     * on currently running animation type.
     *
     * @return {Number}
     */ get: function get() {
            var settings = Glide.settings;
            if (Glide.isType("slider") && Components.Run.offset) return settings.rewindDuration;
            return settings.animationDuration;
        }
    });
    /**
   * Set transition `style` value:
   * - on each moving, because it may be cleared by offset move
   */ Events.on("move", function() {
        Transition.set();
    });
    /**
   * Disable transition:
   * - before initial build to avoid transitioning from `0` to `startAt` index
   * - while resizing window and recalculating dimensions
   * - on jumping from offset transition at start and end edges in `carousel` type
   */ Events.on([
        "build.before",
        "resize",
        "translate.jump"
    ], function() {
        Transition.disable();
    });
    /**
   * Enable transition:
   * - on each running, because it may be disabled by offset move
   */ Events.on("run", function() {
        Transition.enable();
    });
    /**
   * Remove transition:
   * - on destroying to bring markup to its inital state
   */ Events.on("destroy", function() {
        Transition.remove();
    });
    return Transition;
}
/**
 * Test via a getter in the options object to see
 * if the passive property is accessed.
 *
 * @see https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
 */ var $18c4610f4512b4f1$var$supportsPassive = false;
try {
    var $18c4610f4512b4f1$var$opts = Object.defineProperty({}, "passive", {
        get: function get() {
            $18c4610f4512b4f1$var$supportsPassive = true;
        }
    });
    window.addEventListener("testPassive", null, $18c4610f4512b4f1$var$opts);
    window.removeEventListener("testPassive", null, $18c4610f4512b4f1$var$opts);
} catch (e) {}
var $18c4610f4512b4f1$var$supportsPassive$1 = $18c4610f4512b4f1$var$supportsPassive;
var $18c4610f4512b4f1$var$START_EVENTS = [
    "touchstart",
    "mousedown"
];
var $18c4610f4512b4f1$var$MOVE_EVENTS = [
    "touchmove",
    "mousemove"
];
var $18c4610f4512b4f1$var$END_EVENTS = [
    "touchend",
    "touchcancel",
    "mouseup",
    "mouseleave"
];
var $18c4610f4512b4f1$var$MOUSE_EVENTS = [
    "mousedown",
    "mousemove",
    "mouseup",
    "mouseleave"
];
function $18c4610f4512b4f1$var$Swipe(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $18c4610f4512b4f1$var$EventsBinder();
    var swipeSin = 0;
    var swipeStartX = 0;
    var swipeStartY = 0;
    var disabled = false;
    var capture = $18c4610f4512b4f1$var$supportsPassive$1 ? {
        passive: true
    } : false;
    var Swipe = {
        /**
     * Initializes swipe bindings.
     *
     * @return {Void}
     */ mount: function mount() {
            this.bindSwipeStart();
        },
        /**
     * Handler for `swipestart` event. Calculates entry points of the user's tap.
     *
     * @param {Object} event
     * @return {Void}
     */ start: function start(event) {
            if (!disabled && !Glide.disabled) {
                this.disable();
                var swipe = this.touches(event);
                swipeSin = null;
                swipeStartX = $18c4610f4512b4f1$var$toInt(swipe.pageX);
                swipeStartY = $18c4610f4512b4f1$var$toInt(swipe.pageY);
                this.bindSwipeMove();
                this.bindSwipeEnd();
                Events.emit("swipe.start");
            }
        },
        /**
     * Handler for `swipemove` event. Calculates user's tap angle and distance.
     *
     * @param {Object} event
     */ move: function move(event) {
            if (!Glide.disabled) {
                var _Glide$settings = Glide.settings, touchAngle = _Glide$settings.touchAngle, touchRatio = _Glide$settings.touchRatio, classes = _Glide$settings.classes;
                var swipe = this.touches(event);
                var subExSx = $18c4610f4512b4f1$var$toInt(swipe.pageX) - swipeStartX;
                var subEySy = $18c4610f4512b4f1$var$toInt(swipe.pageY) - swipeStartY;
                var powEX = Math.abs(subExSx << 2);
                var powEY = Math.abs(subEySy << 2);
                var swipeHypotenuse = Math.sqrt(powEX + powEY);
                var swipeCathetus = Math.sqrt(powEY);
                swipeSin = Math.asin(swipeCathetus / swipeHypotenuse);
                if (swipeSin * 180 / Math.PI < touchAngle) {
                    event.stopPropagation();
                    Components.Move.make(subExSx * $18c4610f4512b4f1$var$toFloat(touchRatio));
                    Components.Html.root.classList.add(classes.dragging);
                    Events.emit("swipe.move");
                } else return false;
            }
        },
        /**
     * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
     *
     * @param {Object} event
     * @return {Void}
     */ end: function end(event) {
            if (!Glide.disabled) {
                var _Glide$settings2 = Glide.settings, perSwipe = _Glide$settings2.perSwipe, touchAngle = _Glide$settings2.touchAngle, classes = _Glide$settings2.classes;
                var swipe = this.touches(event);
                var threshold = this.threshold(event);
                var swipeDistance = swipe.pageX - swipeStartX;
                var swipeDeg = swipeSin * 180 / Math.PI;
                this.enable();
                if (swipeDistance > threshold && swipeDeg < touchAngle) Components.Run.make(Components.Direction.resolve("".concat(perSwipe, "<")));
                else if (swipeDistance < -threshold && swipeDeg < touchAngle) Components.Run.make(Components.Direction.resolve("".concat(perSwipe, ">")));
                else // While swipe don't reach distance apply previous transform.
                Components.Move.make();
                Components.Html.root.classList.remove(classes.dragging);
                this.unbindSwipeMove();
                this.unbindSwipeEnd();
                Events.emit("swipe.end");
            }
        },
        /**
     * Binds swipe's starting event.
     *
     * @return {Void}
     */ bindSwipeStart: function bindSwipeStart() {
            var _this = this;
            var _Glide$settings3 = Glide.settings, swipeThreshold = _Glide$settings3.swipeThreshold, dragThreshold = _Glide$settings3.dragThreshold;
            if (swipeThreshold) Binder.on($18c4610f4512b4f1$var$START_EVENTS[0], Components.Html.wrapper, function(event) {
                _this.start(event);
            }, capture);
            if (dragThreshold) Binder.on($18c4610f4512b4f1$var$START_EVENTS[1], Components.Html.wrapper, function(event) {
                _this.start(event);
            }, capture);
        },
        /**
     * Unbinds swipe's starting event.
     *
     * @return {Void}
     */ unbindSwipeStart: function unbindSwipeStart() {
            Binder.off($18c4610f4512b4f1$var$START_EVENTS[0], Components.Html.wrapper, capture);
            Binder.off($18c4610f4512b4f1$var$START_EVENTS[1], Components.Html.wrapper, capture);
        },
        /**
     * Binds swipe's moving event.
     *
     * @return {Void}
     */ bindSwipeMove: function bindSwipeMove() {
            var _this2 = this;
            Binder.on($18c4610f4512b4f1$var$MOVE_EVENTS, Components.Html.wrapper, $18c4610f4512b4f1$var$throttle(function(event) {
                _this2.move(event);
            }, Glide.settings.throttle), capture);
        },
        /**
     * Unbinds swipe's moving event.
     *
     * @return {Void}
     */ unbindSwipeMove: function unbindSwipeMove() {
            Binder.off($18c4610f4512b4f1$var$MOVE_EVENTS, Components.Html.wrapper, capture);
        },
        /**
     * Binds swipe's ending event.
     *
     * @return {Void}
     */ bindSwipeEnd: function bindSwipeEnd() {
            var _this3 = this;
            Binder.on($18c4610f4512b4f1$var$END_EVENTS, Components.Html.wrapper, function(event) {
                _this3.end(event);
            });
        },
        /**
     * Unbinds swipe's ending event.
     *
     * @return {Void}
     */ unbindSwipeEnd: function unbindSwipeEnd() {
            Binder.off($18c4610f4512b4f1$var$END_EVENTS, Components.Html.wrapper);
        },
        /**
     * Normalizes event touches points accorting to different types.
     *
     * @param {Object} event
     */ touches: function touches(event) {
            if ($18c4610f4512b4f1$var$MOUSE_EVENTS.indexOf(event.type) > -1) return event;
            return event.touches[0] || event.changedTouches[0];
        },
        /**
     * Gets value of minimum swipe distance settings based on event type.
     *
     * @return {Number}
     */ threshold: function threshold(event) {
            var settings = Glide.settings;
            if ($18c4610f4512b4f1$var$MOUSE_EVENTS.indexOf(event.type) > -1) return settings.dragThreshold;
            return settings.swipeThreshold;
        },
        /**
     * Enables swipe event.
     *
     * @return {self}
     */ enable: function enable() {
            disabled = false;
            Components.Transition.enable();
            return this;
        },
        /**
     * Disables swipe event.
     *
     * @return {self}
     */ disable: function disable() {
            disabled = true;
            Components.Transition.disable();
            return this;
        }
    };
    /**
   * Add component class:
   * - after initial building
   */ Events.on("build.after", function() {
        Components.Html.root.classList.add(Glide.settings.classes.swipeable);
    });
    /**
   * Remove swiping bindings:
   * - on destroying, to remove added EventListeners
   */ Events.on("destroy", function() {
        Swipe.unbindSwipeStart();
        Swipe.unbindSwipeMove();
        Swipe.unbindSwipeEnd();
        Binder.destroy();
    });
    return Swipe;
}
function $18c4610f4512b4f1$var$Images(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $18c4610f4512b4f1$var$EventsBinder();
    var Images = {
        /**
     * Binds listener to glide wrapper.
     *
     * @return {Void}
     */ mount: function mount() {
            this.bind();
        },
        /**
     * Binds `dragstart` event on wrapper to prevent dragging images.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on("dragstart", Components.Html.wrapper, this.dragstart);
        },
        /**
     * Unbinds `dragstart` event on wrapper.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off("dragstart", Components.Html.wrapper);
        },
        /**
     * Event handler. Prevents dragging.
     *
     * @return {Void}
     */ dragstart: function dragstart(event) {
            event.preventDefault();
        }
    };
    /**
   * Remove bindings from images:
   * - on destroying, to remove added EventListeners
   */ Events.on("destroy", function() {
        Images.unbind();
        Binder.destroy();
    });
    return Images;
}
function $18c4610f4512b4f1$var$Anchors(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $18c4610f4512b4f1$var$EventsBinder();
    /**
   * Holds detaching status of anchors.
   * Prevents detaching of already detached anchors.
   *
   * @private
   * @type {Boolean}
   */ var detached = false;
    /**
   * Holds preventing status of anchors.
   * If `true` redirection after click will be disabled.
   *
   * @private
   * @type {Boolean}
   */ var prevented = false;
    var Anchors = {
        /**
     * Setups a initial state of anchors component.
     *
     * @returns {Void}
     */ mount: function mount() {
            /**
       * Holds collection of anchors elements.
       *
       * @private
       * @type {HTMLCollection}
       */ this._a = Components.Html.wrapper.querySelectorAll("a");
            this.bind();
        },
        /**
     * Binds events to anchors inside a track.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on("click", Components.Html.wrapper, this.click);
        },
        /**
     * Unbinds events attached to anchors inside a track.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off("click", Components.Html.wrapper);
        },
        /**
     * Handler for click event. Prevents clicks when glide is in `prevent` status.
     *
     * @param  {Object} event
     * @return {Void}
     */ click: function click(event) {
            if (prevented) {
                event.stopPropagation();
                event.preventDefault();
            }
        },
        /**
     * Detaches anchors click event inside glide.
     *
     * @return {self}
     */ detach: function detach() {
            prevented = true;
            if (!detached) {
                for(var i = 0; i < this.items.length; i++)this.items[i].draggable = false;
                detached = true;
            }
            return this;
        },
        /**
     * Attaches anchors click events inside glide.
     *
     * @return {self}
     */ attach: function attach() {
            prevented = false;
            if (detached) {
                for(var i = 0; i < this.items.length; i++)this.items[i].draggable = true;
                detached = false;
            }
            return this;
        }
    };
    $18c4610f4512b4f1$var$define(Anchors, "items", {
        /**
     * Gets collection of the arrows HTML elements.
     *
     * @return {HTMLElement[]}
     */ get: function get() {
            return Anchors._a;
        }
    });
    /**
   * Detach anchors inside slides:
   * - on swiping, so they won't redirect to its `href` attributes
   */ Events.on("swipe.move", function() {
        Anchors.detach();
    });
    /**
   * Attach anchors inside slides:
   * - after swiping and transitions ends, so they can redirect after click again
   */ Events.on("swipe.end", function() {
        Components.Transition.after(function() {
            Anchors.attach();
        });
    });
    /**
   * Unbind anchors inside slides:
   * - on destroying, to bring anchors to its initial state
   */ Events.on("destroy", function() {
        Anchors.attach();
        Anchors.unbind();
        Binder.destroy();
    });
    return Anchors;
}
var $18c4610f4512b4f1$var$NAV_SELECTOR = '[data-glide-el="controls[nav]"]';
var $18c4610f4512b4f1$var$CONTROLS_SELECTOR = '[data-glide-el^="controls"]';
var $18c4610f4512b4f1$var$PREVIOUS_CONTROLS_SELECTOR = "".concat($18c4610f4512b4f1$var$CONTROLS_SELECTOR, ' [data-glide-dir*="<"]');
var $18c4610f4512b4f1$var$NEXT_CONTROLS_SELECTOR = "".concat($18c4610f4512b4f1$var$CONTROLS_SELECTOR, ' [data-glide-dir*=">"]');
function $18c4610f4512b4f1$var$Controls(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $18c4610f4512b4f1$var$EventsBinder();
    var capture = $18c4610f4512b4f1$var$supportsPassive$1 ? {
        passive: true
    } : false;
    var Controls = {
        /**
     * Inits arrows. Binds events listeners
     * to the arrows HTML elements.
     *
     * @return {Void}
     */ mount: function mount() {
            /**
       * Collection of navigation HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */ this._n = Components.Html.root.querySelectorAll($18c4610f4512b4f1$var$NAV_SELECTOR);
            /**
       * Collection of controls HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */ this._c = Components.Html.root.querySelectorAll($18c4610f4512b4f1$var$CONTROLS_SELECTOR);
            /**
       * Collection of arrow control HTML elements.
       *
       * @private
       * @type {Object}
       */ this._arrowControls = {
                previous: Components.Html.root.querySelectorAll($18c4610f4512b4f1$var$PREVIOUS_CONTROLS_SELECTOR),
                next: Components.Html.root.querySelectorAll($18c4610f4512b4f1$var$NEXT_CONTROLS_SELECTOR)
            };
            this.addBindings();
        },
        /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */ setActive: function setActive() {
            for(var i = 0; i < this._n.length; i++)this.addClass(this._n[i].children);
        },
        /**
     * Removes active class to current slide.
     *
     * @return {Void}
     */ removeActive: function removeActive() {
            for(var i = 0; i < this._n.length; i++)this.removeClass(this._n[i].children);
        },
        /**
     * Toggles active class on items inside navigation.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */ addClass: function addClass(controls) {
            var settings = Glide.settings;
            var item = controls[Glide.index];
            if (!item) return;
            if (item) {
                item.classList.add(settings.classes.nav.active);
                $18c4610f4512b4f1$var$siblings(item).forEach(function(sibling) {
                    sibling.classList.remove(settings.classes.nav.active);
                });
            }
        },
        /**
     * Removes active class from active control.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */ removeClass: function removeClass(controls) {
            var item = controls[Glide.index];
            if (item) item.classList.remove(Glide.settings.classes.nav.active);
        },
        /**
     * Calculates, removes or adds `Glide.settings.classes.disabledArrow` class on the control arrows
     */ setArrowState: function setArrowState() {
            if (Glide.settings.rewind) return;
            var next = Controls._arrowControls.next;
            var previous = Controls._arrowControls.previous;
            this.resetArrowState(next, previous);
            if (Glide.index === 0) this.disableArrow(previous);
            if (Glide.index === Components.Run.length) this.disableArrow(next);
        },
        /**
     * Removes `Glide.settings.classes.disabledArrow` from given NodeList elements
     *
     * @param {NodeList[]} lists
     */ resetArrowState: function resetArrowState() {
            var settings = Glide.settings;
            for(var _len = arguments.length, lists = new Array(_len), _key = 0; _key < _len; _key++)lists[_key] = arguments[_key];
            lists.forEach(function(list) {
                $18c4610f4512b4f1$var$toArray(list).forEach(function(element) {
                    element.classList.remove(settings.classes.arrow.disabled);
                });
            });
        },
        /**
     * Adds `Glide.settings.classes.disabledArrow` to given NodeList elements
     *
     * @param {NodeList[]} lists
     */ disableArrow: function disableArrow() {
            var settings = Glide.settings;
            for(var _len2 = arguments.length, lists = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)lists[_key2] = arguments[_key2];
            lists.forEach(function(list) {
                $18c4610f4512b4f1$var$toArray(list).forEach(function(element) {
                    element.classList.add(settings.classes.arrow.disabled);
                });
            });
        },
        /**
     * Adds handles to the each group of controls.
     *
     * @return {Void}
     */ addBindings: function addBindings() {
            for(var i = 0; i < this._c.length; i++)this.bind(this._c[i].children);
        },
        /**
     * Removes handles from the each group of controls.
     *
     * @return {Void}
     */ removeBindings: function removeBindings() {
            for(var i = 0; i < this._c.length; i++)this.unbind(this._c[i].children);
        },
        /**
     * Binds events to arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */ bind: function bind(elements) {
            for(var i = 0; i < elements.length; i++){
                Binder.on("click", elements[i], this.click);
                Binder.on("touchstart", elements[i], this.click, capture);
            }
        },
        /**
     * Unbinds events binded to the arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */ unbind: function unbind(elements) {
            for(var i = 0; i < elements.length; i++)Binder.off([
                "click",
                "touchstart"
            ], elements[i]);
        },
        /**
     * Handles `click` event on the arrows HTML elements.
     * Moves slider in direction given via the
     * `data-glide-dir` attribute.
     *
     * @param {Object} event
     * @return {void}
     */ click: function click(event) {
            if (!$18c4610f4512b4f1$var$supportsPassive$1 && event.type === "touchstart") event.preventDefault();
            var direction = event.currentTarget.getAttribute("data-glide-dir");
            Components.Run.make(Components.Direction.resolve(direction));
        }
    };
    $18c4610f4512b4f1$var$define(Controls, "items", {
        /**
     * Gets collection of the controls HTML elements.
     *
     * @return {HTMLElement[]}
     */ get: function get() {
            return Controls._c;
        }
    });
    /**
   * Swap active class of current navigation item:
   * - after mounting to set it to initial index
   * - after each move to the new index
   */ Events.on([
        "mount.after",
        "move.after"
    ], function() {
        Controls.setActive();
    });
    /**
   * Add or remove disabled class of arrow elements
   */ Events.on([
        "mount.after",
        "run"
    ], function() {
        Controls.setArrowState();
    });
    /**
   * Remove bindings and HTML Classes:
   * - on destroying, to bring markup to its initial state
   */ Events.on("destroy", function() {
        Controls.removeBindings();
        Controls.removeActive();
        Binder.destroy();
    });
    return Controls;
}
function $18c4610f4512b4f1$var$Keyboard(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $18c4610f4512b4f1$var$EventsBinder();
    var Keyboard = {
        /**
     * Binds keyboard events on component mount.
     *
     * @return {Void}
     */ mount: function mount() {
            if (Glide.settings.keyboard) this.bind();
        },
        /**
     * Adds keyboard press events.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on("keyup", document, this.press);
        },
        /**
     * Removes keyboard press events.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off("keyup", document);
        },
        /**
     * Handles keyboard's arrows press and moving glide foward and backward.
     *
     * @param  {Object} event
     * @return {Void}
     */ press: function press(event) {
            var perSwipe = Glide.settings.perSwipe;
            if (event.code === "ArrowRight") Components.Run.make(Components.Direction.resolve("".concat(perSwipe, ">")));
            if (event.code === "ArrowLeft") Components.Run.make(Components.Direction.resolve("".concat(perSwipe, "<")));
        }
    };
    /**
   * Remove bindings from keyboard:
   * - on destroying to remove added events
   * - on updating to remove events before remounting
   */ Events.on([
        "destroy",
        "update"
    ], function() {
        Keyboard.unbind();
    });
    /**
   * Remount component
   * - on updating to reflect potential changes in settings
   */ Events.on("update", function() {
        Keyboard.mount();
    });
    /**
   * Destroy binder:
   * - on destroying to remove listeners
   */ Events.on("destroy", function() {
        Binder.destroy();
    });
    return Keyboard;
}
function $18c4610f4512b4f1$var$Autoplay(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $18c4610f4512b4f1$var$EventsBinder();
    var Autoplay = {
        /**
     * Initializes autoplaying and events.
     *
     * @return {Void}
     */ mount: function mount() {
            this.enable();
            this.start();
            if (Glide.settings.hoverpause) this.bind();
        },
        /**
     * Enables autoplaying
     *
     * @returns {Void}
     */ enable: function enable() {
            this._e = true;
        },
        /**
     * Disables autoplaying.
     *
     * @returns {Void}
     */ disable: function disable() {
            this._e = false;
        },
        /**
     * Starts autoplaying in configured interval.
     *
     * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Void}
     */ start: function start() {
            var _this = this;
            if (!this._e) return;
            this.enable();
            if (Glide.settings.autoplay) {
                if ($18c4610f4512b4f1$var$isUndefined(this._i)) this._i = setInterval(function() {
                    _this.stop();
                    Components.Run.make(">");
                    _this.start();
                    Events.emit("autoplay");
                }, this.time);
            }
        },
        /**
     * Stops autorunning of the glide.
     *
     * @return {Void}
     */ stop: function stop() {
            this._i = clearInterval(this._i);
        },
        /**
     * Stops autoplaying while mouse is over glide's area.
     *
     * @return {Void}
     */ bind: function bind() {
            var _this2 = this;
            Binder.on("mouseover", Components.Html.root, function() {
                if (_this2._e) _this2.stop();
            });
            Binder.on("mouseout", Components.Html.root, function() {
                if (_this2._e) _this2.start();
            });
        },
        /**
     * Unbind mouseover events.
     *
     * @returns {Void}
     */ unbind: function unbind() {
            Binder.off([
                "mouseover",
                "mouseout"
            ], Components.Html.root);
        }
    };
    $18c4610f4512b4f1$var$define(Autoplay, "time", {
        /**
     * Gets time period value for the autoplay interval. Prioritizes
     * times in `data-glide-autoplay` attrubutes over options.
     *
     * @return {Number}
     */ get: function get() {
            var autoplay = Components.Html.slides[Glide.index].getAttribute("data-glide-autoplay");
            if (autoplay) return $18c4610f4512b4f1$var$toInt(autoplay);
            return $18c4610f4512b4f1$var$toInt(Glide.settings.autoplay);
        }
    });
    /**
   * Stop autoplaying and unbind events:
   * - on destroying, to clear defined interval
   * - on updating via API to reset interval that may changed
   */ Events.on([
        "destroy",
        "update"
    ], function() {
        Autoplay.unbind();
    });
    /**
   * Stop autoplaying:
   * - before each run, to restart autoplaying
   * - on pausing via API
   * - on destroying, to clear defined interval
   * - while starting a swipe
   * - on updating via API to reset interval that may changed
   */ Events.on([
        "run.before",
        "swipe.start",
        "update"
    ], function() {
        Autoplay.stop();
    });
    Events.on([
        "pause",
        "destroy"
    ], function() {
        Autoplay.disable();
        Autoplay.stop();
    });
    /**
   * Start autoplaying:
   * - after each run, to restart autoplaying
   * - on playing via API
   * - while ending a swipe
   */ Events.on([
        "run.after",
        "swipe.end"
    ], function() {
        Autoplay.start();
    });
    /**
   * Start autoplaying:
   * - after each run, to restart autoplaying
   * - on playing via API
   * - while ending a swipe
   */ Events.on([
        "play"
    ], function() {
        Autoplay.enable();
        Autoplay.start();
    });
    /**
   * Remount autoplaying:
   * - on updating via API to reset interval that may changed
   */ Events.on("update", function() {
        Autoplay.mount();
    });
    /**
   * Destroy a binder:
   * - on destroying glide instance to clearup listeners
   */ Events.on("destroy", function() {
        Binder.destroy();
    });
    return Autoplay;
}
/**
 * Sorts keys of breakpoint object so they will be ordered from lower to bigger.
 *
 * @param {Object} points
 * @returns {Object}
 */ function $18c4610f4512b4f1$var$sortBreakpoints(points) {
    if ($18c4610f4512b4f1$var$isObject(points)) return $18c4610f4512b4f1$var$sortKeys(points);
    else $18c4610f4512b4f1$var$warn("Breakpoints option must be an object");
    return {};
}
function $18c4610f4512b4f1$var$Breakpoints(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $18c4610f4512b4f1$var$EventsBinder();
    /**
   * Holds reference to settings.
   *
   * @type {Object}
   */ var settings = Glide.settings;
    /**
   * Holds reference to breakpoints object in settings. Sorts breakpoints
   * from smaller to larger. It is required in order to proper
   * matching currently active breakpoint settings.
   *
   * @type {Object}
   */ var points = $18c4610f4512b4f1$var$sortBreakpoints(settings.breakpoints);
    /**
   * Cache initial settings before overwritting.
   *
   * @type {Object}
   */ var defaults = Object.assign({}, settings);
    var Breakpoints = {
        /**
     * Matches settings for currectly matching media breakpoint.
     *
     * @param {Object} points
     * @returns {Object}
     */ match: function match(points) {
            if (typeof window.matchMedia !== "undefined") {
                for(var point in points)if (points.hasOwnProperty(point)) {
                    if (window.matchMedia("(max-width: ".concat(point, "px)")).matches) return points[point];
                }
            }
            return defaults;
        }
    };
    /**
   * Overwrite instance settings with currently matching breakpoint settings.
   * This happens right after component initialization.
   */ Object.assign(settings, Breakpoints.match(points));
    /**
   * Update glide with settings of matched brekpoint:
   * - window resize to update slider
   */ Binder.on("resize", window, $18c4610f4512b4f1$var$throttle(function() {
        Glide.settings = $18c4610f4512b4f1$var$mergeOptions(settings, Breakpoints.match(points));
    }, Glide.settings.throttle));
    /**
   * Resort and update default settings:
   * - on reinit via API, so breakpoint matching will be performed with options
   */ Events.on("update", function() {
        points = $18c4610f4512b4f1$var$sortBreakpoints(points);
        defaults = Object.assign({}, settings);
    });
    /**
   * Unbind resize listener:
   * - on destroying, to bring markup to its initial state
   */ Events.on("destroy", function() {
        Binder.off("resize", window);
    });
    return Breakpoints;
}
var $18c4610f4512b4f1$var$COMPONENTS = {
    // Required
    Html: $18c4610f4512b4f1$var$Html,
    Translate: $18c4610f4512b4f1$var$Translate,
    Transition: $18c4610f4512b4f1$var$Transition,
    Direction: $18c4610f4512b4f1$var$Direction,
    Peek: $18c4610f4512b4f1$var$Peek,
    Sizes: $18c4610f4512b4f1$var$Sizes,
    Gaps: $18c4610f4512b4f1$var$Gaps,
    Move: $18c4610f4512b4f1$var$Move,
    Clones: $18c4610f4512b4f1$var$Clones,
    Resize: $18c4610f4512b4f1$var$Resize,
    Build: $18c4610f4512b4f1$var$Build,
    Run: $18c4610f4512b4f1$var$Run,
    // Optional
    Swipe: $18c4610f4512b4f1$var$Swipe,
    Images: $18c4610f4512b4f1$var$Images,
    Anchors: $18c4610f4512b4f1$var$Anchors,
    Controls: $18c4610f4512b4f1$var$Controls,
    Keyboard: $18c4610f4512b4f1$var$Keyboard,
    Autoplay: $18c4610f4512b4f1$var$Autoplay,
    Breakpoints: $18c4610f4512b4f1$var$Breakpoints
};
var $18c4610f4512b4f1$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Core) {
    $18c4610f4512b4f1$var$_inherits(Glide, _Core);
    var _super = $18c4610f4512b4f1$var$_createSuper(Glide);
    function Glide() {
        $18c4610f4512b4f1$var$_classCallCheck(this, Glide);
        return _super.apply(this, arguments);
    }
    $18c4610f4512b4f1$var$_createClass(Glide, [
        {
            key: "mount",
            value: function mount() {
                var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return $18c4610f4512b4f1$var$_get($18c4610f4512b4f1$var$_getPrototypeOf(Glide.prototype), "mount", this).call(this, Object.assign({}, $18c4610f4512b4f1$var$COMPONENTS, extensions));
            }
        }
    ]);
    return Glide;
}($18c4610f4512b4f1$var$Glide$1);


class $bb5240053b0c4187$var$GlideSlideshow {
    constructor(el, options){
        this.el = el;
        this.options = options;
        this.glideArrowLeft = this.el.querySelector(".glide__arrow--prev");
        this.glideArrowRight = this.el.querySelector(".glide__arrow--next");
        this.id = this.el.getAttribute("id");
        this.glide = undefined;
        this.countSlides = this.el.querySelectorAll(".glide__slide").length;
        this._init();
    }
    /*
   * INIT
   */ _init() {
        this.glide = new (0, $18c4610f4512b4f1$export$2e2bcd8739ae039)(this.el, {
            type: "carousel",
            autoplay: 5000,
            animationDuration: 800,
            keyboard: true,
            hoverpause: false,
            gap: 0,
            swipeThreshold: 30
        });
        //update active caption
        if (this.el.querySelectorAll("[data-glide-caption]").length > 0) this.el.querySelectorAll("[data-glide-caption]")[0].classList.add("active");
        this.glide.on("run", (move)=>{
            //update active caption
            if (this.el.querySelectorAll("[data-glide-caption]").length > 0) {
                this.el.querySelectorAll("[data-glide-caption]").forEach((el)=>{
                    el.classList.remove("active");
                });
                this.el.querySelectorAll("[data-glide-caption]")[this.glide.index].classList.add("active");
            }
            //update counter
            if (this.el.querySelector("[data-glide-counter]")) this.el.querySelector("[data-glide-counter] [data-glide-current]").innerHTML = this.glide.index + 1;
        });
        this.glide.on("build.after", ()=>this.el.classList.add("glide--ready"));
        //update counter
        if (this.el.querySelector("[data-glide-counter]")) {
            this.el.querySelector("[data-glide-counter] [data-glide-current]").innerHTML = 1;
            this.el.querySelector("[data-glide-counter] [data-glide-total]").innerHTML = this.countSlides;
        }
        if (this.countSlides > 1) //init/mount slide
        setTimeout(()=>{
            this.glide.mount();
        }, 1); //https://github.com/glidejs/glide/issues/89
        if (this.glideArrowLeft) this.glideArrowLeft.addEventListener("click", ()=>this.glide.go("<"));
        if (this.glideArrowRight) this.glideArrowRight.addEventListener("click", ()=>this.glide.go(">"));
    }
    /*
   * Destroy
   */ destroy() {
        this.glide.destroy();
    }
}
var $bb5240053b0c4187$export$2e2bcd8739ae039 = $bb5240053b0c4187$var$GlideSlideshow;


class $3f56b7aaaa640ed3$export$2e2bcd8739ae039 {
    constructor(el){
        this.el = el;
        this.pswpElement = document.querySelectorAll(".pswp")[0];
        this.options = {
            index: 0,
            mainClass: "pswp--minimal--dark",
            barsSize: {
                top: 10,
                bottom: 10
            },
            captionEl: true,
            fullscreenEl: false,
            shareEl: false,
            bgOpacity: 0.65,
            tapToClose: true,
            tapToToggleControls: false,
            history: false
        };
        new (0, $bb5240053b0c4187$export$2e2bcd8739ae039)(this.el);
        this.el.querySelectorAll("[data-pswp-src]").forEach((img, index)=>{
            img.addEventListener("click", (e)=>{
                e.preventDefault();
                //if is dragging, don't open photoswipe
                if (img.getAttribute("draggable") == "false") return;
                const pswpItems = [];
                this.options.index = index - 1;
                this.el.querySelectorAll(".glide__slide:not(.glide__slide--clone) [data-pswp-src]").forEach((img)=>{
                    const item = {
                        src: img.getAttribute("data-pswp-src"),
                        w: img.getAttribute("data-pswp-width"),
                        h: img.getAttribute("data-pswp-height")
                    };
                    pswpItems.push(item);
                });
                const gallery = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, pswpItems, this.options);
                gallery.init();
            });
        });
    }
}


class $09bad0736b074fc1$export$2e2bcd8739ae039 {
    constructor(){
        this.pinnedItineraries = JSON.parse(localStorage.getItem("data-saved-itineraries"));
        this.itinerariesData = undefined;
        this.menuItinerariesEl = document.querySelector("[data-itineraries]");
        this.pinnedItinerariesContainerEl = document.querySelector("[data-saved-itineraries]");
        this._initMenu();
    }
    async _initMenu() {
        // this.itinerariesData = await this._addItinerariesMenuOptions();
        this._fillGlobalOptions();
        this._fillPagesLinks();
        this._initAccordions();
        document.querySelector(`[data-tagline-lang="${window.language}"]`).classList.add("show");
        if (this.pinnedItineraries) this.pinnedItineraries.forEach((pinnedItinerary)=>{
            const itineraryId = "itinerary-" + pinnedItinerary[window.language].id;
            document.querySelector('[data-itinerary="' + itineraryId + '"] .fa-thumbtack').classList.add(".fas");
            document.querySelector('[data-itinerary="' + itineraryId + '"] .fa-thumbtack').classList.remove(".far");
            this._addPinnedItenerary(itineraryId, pinnedItinerary[window.language]);
        });
        document.querySelectorAll("[data-itinerary]").forEach((el)=>{
            const itinerary = el.getAttribute("data-itinerary");
            const currentItineraryId = itinerary.replace("itinerary-", "");
            const thumbtackEl = el.querySelector(".fa-thumbtack");
            if (this.pinnedItineraries?.length > 0) {
                let itineraryIsPinned = false;
                for (const pinnedItinerary of this.pinnedItineraries)if (pinnedItinerary[window.language].id == currentItineraryId) {
                    itineraryIsPinned = true;
                    break;
                }
                if (itineraryIsPinned) el.classList.add("pinned");
                else el.classList.remove("pinned");
            }
            thumbtackEl.addEventListener("click", (e)=>this._thumbtackClickHandler(e.currentTarget, itinerary));
        });
    }
    _fillGlobalOptions() {
        return fetch(window.ENV.API_BASE_PATH + "/global-option/?populate=deep&locale=" + window.language).then((response)=>response.json()).then((data)=>{
            if (document.querySelector("[data-home-gpx]") && data.data.attributes.gpx_file.data) document.querySelector("[data-home-gpx]").setAttribute("href", window.ENV.API_ASSETS_BASE_PATH + data.data.attributes.gpx_file.data.attributes.url);
            if (document.querySelector("[data-home-sos]") && data.data.attributes.sos_number) document.querySelector("[data-home-sos]").setAttribute("href", "tel:" + data.data.attributes.sos_number);
            if (data.data.attributes.bg_images.length > 0 && document.querySelector("[data-home-bg]")) {
                if (data.data.attributes.bg_images.length == 1) document.querySelector("[data-home-bg]").innerHTML = this._getImageHtml(data.data.attributes.bg_images[0]);
                else {
                    document.querySelector("[data-home-bg]").innerHTML = this._getSlideshowHtml(data.data.attributes.bg_images);
                    new (0, $3f56b7aaaa640ed3$export$2e2bcd8739ae039)(document.querySelector("[data-home-bg] .ma-slideshow"));
                }
            }
        });
    }
    _fillPagesLinks() {
        const PAGES_FILTER = [
            "sobre",
            "about",
            "acerca",
            "como-chegar",
            "how-to-get-there",
            "como-llegar",
            "sinaletica",
            "signage",
            "senalizacion",
            "conselhos-de-seguranca",
            "safety-advice",
            "consejo-de-seguridad",
            "comunidade",
            "community",
            "comunidad"
        ];
        return fetch(window.ENV.API_BASE_PATH + "/pages/?populate=*&locale=" + window.language).then((response)=>response.json()).then((data)=>{
            if (document.querySelector("[data-pages]") && data.data.length > 0) {
                data.data.forEach((page)=>{
                    let match;
                    if (match = /segmento?-(.)/.exec(page.attributes.slug)) {
                        const segmentEl = document.querySelector(`[data-segment="${match[1]}"]`);
                        if (segmentEl) {
                            segmentEl.innerText = page.attributes.title;
                            segmentEl.setAttribute("href", `page/?slug=${page.attributes.slug}`);
                        }
                    }
                    if (PAGES_FILTER.includes(page.attributes.slug) || page.attributes.slug.match(/segmento?-/)) return;
                    document.querySelector("[data-pages]").innerHTML += `<li class="nav-menu__opt nav-menu__opt--flex">
                <a class="nav-menu__opt-text" href="page/?slug=${page.attributes.slug}" data-menu-opt="page">${page.attributes.title}</a>
              </li>`;
                });
                this._initAccordions();
            }
        });
    }
    _getRandomInt(max) {
        return Math.floor(Math.random() * max);
    }
    _addItinerariesMenuOptions() {
        return fetch(window.ENV.API_BASE_PATH + "/itineraries/?populate=*&locale=" + window.language).then((response)=>response.json()).then((data)=>{
            const menuOptionsHtml = data.data.reduce((accumulator, itinerary)=>{
                const html = `<li class="nav-menu__opt" data-itinerary="itinerary-${itinerary.id}" data-color="${itinerary.attributes.color}">
              <div class="strip-color" style="background-color: ${itinerary.attributes.color}"></div>
              <div class="nav-menu__opt-text">
                <a class="nav-menu__opt-link" href="roteiro/?id=${itinerary.id}">${itinerary.attributes.name}</a>
                <span class="nav-menu__opt-pin">
                  <i class="fas fa-thumbtack"></i>
                </span>
              </div>
            </li>`;
                return accumulator + html;
            }, "");
            this.menuItinerariesEl.innerHTML = menuOptionsHtml;
            return data.data;
        }).catch((error)=>console.error("Erro:", error));
    }
    _initAccordions() {
        if (document.querySelectorAll(".ma-accordion").length > 0) document.querySelectorAll(".ma-accordion").forEach((el, i)=>{
            let accordion = undefined;
            if (el.getAttribute("id") === "accordion-languages") accordion = new MaAccordion(el, true, null, null, null, null, ()=>$("#homepage").animate({
                    scrollTop: document.querySelector("#homepage").clientHeight
                }, 300));
            else accordion = new MaAccordion(el, true);
            if (i == document.querySelectorAll(".ma-accordion").length - 1) document.body.classList.add("body-ready");
        });
    }
    _addPinnedItenerary(itinerary, data) {
        const pinnedItineraryHtml = `<li class="nav-menu__opt pinned bg-color--itinerary-light" data-itinerary-pinned="${itinerary}">
        <div class="strip-color" style="background-color: ${data.color}"></div>
        <div class="nav-menu__opt-text">
          <a class="nav-menu__opt-link" href="roteiro/?id=${data.id}">
            ${data.title}
          </a>
          <span class="nav-menu__opt-pin">
            <i class="fas fa-thumbtack"></i>
          </span>
        </div>
      </li>`;
        this.pinnedItinerariesContainerEl.insertAdjacentHTML("beforeend", pinnedItineraryHtml);
        const thumbtackEl = document.querySelector('[data-itinerary-pinned="' + itinerary + '"] .fa-thumbtack');
        thumbtackEl.addEventListener("click", (e)=>this._thumbtackClickHandler(e.currentTarget, itinerary));
    }
    _removePinnedItenerary(itinerary) {
        document.querySelector('[data-itinerary="' + itinerary + '"]').classList.remove("pinned");
        document.querySelector('[data-itinerary-pinned="' + itinerary + '"]').remove();
    }
    _thumbtackClickHandler(thumbtackEl, itinerary) {
        const optionEl = thumbtackEl.closest(".nav-menu__opt");
        const currentItineraryId = itinerary.replace("itinerary-", "");
        const currentItineraryData = this.itinerariesData.filter((el)=>el.id == currentItineraryId)[0];
        let itineraries = JSON.parse(localStorage.getItem("data-saved-itineraries")) || [];
        if (optionEl.classList.contains("pinned")) {
            optionEl.classList.remove("pinned");
            itineraries = itineraries.filter((itinerary)=>itinerary[window.language].id != currentItineraryId);
            localStorage.setItem("data-saved-itineraries", JSON.stringify(itineraries));
            this._removePinnedItenerary(itinerary);
        } else {
            optionEl.classList.add("pinned");
            let data = {};
            //current language itinerary
            data[currentItineraryData.attributes.locale] = {
                id: currentItineraryData.id,
                title: currentItineraryData.attributes.name,
                color: currentItineraryData.attributes.color
            };
            //translated itinerary
            data[currentItineraryData.attributes.localizations.data[0].attributes.locale] = {
                id: currentItineraryData.attributes.localizations.data[0].id,
                title: currentItineraryData.attributes.localizations.data[0].attributes.name,
                color: currentItineraryData.attributes.localizations.data[0].attributes.color
            };
            itineraries.push(data);
            localStorage.setItem("data-saved-itineraries", JSON.stringify(itineraries));
            this._addPinnedItenerary(itinerary, data[window.language]);
        }
    }
    _getSlideshowHtml(imagesData) {
        return `<div class="ma-slideshow" id="ma-slideshow-1">
              <div class="glide" data-glide-slideshow="data-glide-slideshow">
                <div class="glide__track" data-glide-el="track">
                  <ul class="glide__slides">
                  ${imagesData.reduce((acc, val)=>acc + `<li class="glide__slide">
                      <div class="glide__bg" style="background-image: url(${window.ENV.API_ASSETS_BASE_PATH + val.image.data.attributes.url}); background-position: ${val.bg_x}% ${val.bg_y}%;"></div>
                    </li>`, "")}
                  </ul>
                </div>
                <div class="ma-slideshow__controls glide__arrows" data-glide-el="controls">
                  <button class="glide__arrow glide__arrow--prev" data-glide-dir="&lt;">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 18.8 30.3" style="enable-background:new 0 0 18.8 30.3;" xml:space="preserve">
                      <polygon fill="#2A2827" points="16.3,30.3 18.8,27.5 5.4,15.1 18.8,2.7 16.3,0 0,15.1"></polygon>
                    </svg>
                  </button>
                  <button class="glide__arrow glide__arrow--next" data-glide-dir="&gt;">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 18.8 30.3" style="enable-background:new 0 0 18.8 30.3;" xml:space="preserve">
                      <polygon fill="#2A2827" points="2.5,0 0,2.8 13.4,15.2 0,27.6 2.5,30.3 18.8,15.2"></polygon>
                    </svg>
                  </button>
                </div>
              </div>
            </div>`;
    }
    _getImageHtml(imageData) {
        return `<div class="fullwidth-image">
              <a data-pswp-width="${imageData.attributes.width}" data-pswp-height="${imageData.attributes.height}" data-pswp-src="${window.ENV.API_ASSETS_BASE_PATH + imageData.attributes.url}">
                <img class="lazyload" data-srcset="${this._getSrcsetImages(imageData.attributes)}" data-sizes="auto" width="${imageData.attributes.width}" height="${imageData.attributes.height}" src="${window.ENV.API_ASSETS_BASE_PATH + imageData.attributes.formats.small.url}"/>
              </a>
            </div>`;
    }
    _getSrcsetImages(imagesData) {
        let srcset = "";
        if (imagesData.formats.small) srcset += `${window.ENV.API_ASSETS_BASE_PATH + imagesData.formats.small.url} ${imagesData.formats.small.width}w, `;
        if (imagesData.formats.medium) srcset += `${window.ENV.API_ASSETS_BASE_PATH + imagesData.formats.medium.url} ${imagesData.formats.medium.width}w, `;
        if (imagesData.formats.large) srcset += `${window.ENV.API_ASSETS_BASE_PATH + imagesData.formats.large.url} ${imagesData.formats.large.width}w, `;
        srcset += `${window.ENV.API_ASSETS_BASE_PATH + imagesData.url} ${imagesData.width}w`;
        return srcset;
    }
}



class $09fdde2ebe540f0f$var$GenericPage {
    constructor(pageEl, slug){
        this.pageEl = pageEl;
        this.slug = slug;
        this.converter = new showdown.Converter();
        fetch(window.ENV.API_BASE_PATH + "/pages?filters[slug][$eq]=" + this.slug + "&populate=*&locale=" + window.language).then((response)=>response.json()).then((data)=>{
            this._addData(data.data[0]);
        }).catch((error)=>console.error("Erro:", error));
    }
    _addData(pageData) {
        console.log(pageData);
        if (pageData.attributes.color) {
            document.querySelectorAll(".bg-color--itinerary").forEach((el)=>el.classList.remove("bg-color--itinerary"));
            document.querySelectorAll(".bg-color--itinerary-light").forEach((el)=>el.classList.remove("bg-color--itinerary-light"));
        }
        if (pageData.attributes.description && this.pageEl.querySelector("[data-page-description]")) this.pageEl.querySelector("[data-page-description]").innerHTML = this.converter.makeHtml(pageData.attributes.description);
        if (pageData.attributes.images.data?.length > 0 && this.pageEl.querySelector("[data-page-slideshow]")) {
            if (pageData.attributes.images.data?.length == 1) {
                this.pageEl.querySelector("[data-page-slideshow]").innerHTML = this._getImageHtml(pageData.attributes.images.data[0]);
                this._initPhotoSwipe(this.pageEl.querySelector("[data-page-slideshow] [data-pswp-src]"));
            } else {
                this.pageEl.querySelector("[data-page-slideshow]").innerHTML = this._getSlideshowHtml(pageData.attributes.images.data);
                new (0, $3f56b7aaaa640ed3$export$2e2bcd8739ae039)(this.pageEl.querySelector("[data-page-slideshow] .ma-slideshow"));
            }
        }
        if (pageData.attributes.title) {
            if (document.querySelector("[data-title]")) document.querySelector("[data-title]").innerHTML = pageData.attributes.title;
            if (this.pageEl.querySelector("[data-itinerary-title]")) this.pageEl.querySelector("[data-itinerary-title]").innerHTML = pageData.attributes.title;
        }
        if (pageData.attributes.color && document.querySelector("[data-color]")) {
            document.querySelector("[data-color]").style.backgroundColor = pageData.attributes.color;
            document.body.style.backgroundColor = pageData.attributes.color + "cf"; // cf - change hex color opacity
        }
        if (pageData.attributes.text_color && document.querySelector("[data-color]")) {
            const textColor = pageData.attributes.text_color == "light" ? "white" : "black";
            document.querySelector("[data-color]").style.color = textColor;
            this.pageEl.querySelector("[data-page-description]").style.color = textColor;
            this.pageEl.querySelector("[data-itinerary-title]").style.color = textColor;
            if (pageData.attributes.text_color == "light") document.querySelector("[data-color] .heading__back-home").classList.add("heading__back-home--light");
            else document.querySelector("[data-color] .heading__back-home").classList.add("heading__back-home--dark");
        }
    }
    _getSlideshowHtml(imagesData) {
        return `<div class="ma-slideshow" id="ma-slideshow-1">
              <div class="glide" data-glide-slideshow="data-glide-slideshow">
                <div class="glide__track" data-glide-el="track">
                  <ul class="glide__slides">
                  ${imagesData.reduce((acc, val)=>acc + `<li class="glide__slide">
                      <a data-pswp-width="${val.attributes.width}" data-pswp-height="${val.attributes.height}" data-pswp-src="${window.ENV.API_ASSETS_BASE_PATH + val.attributes.url}">
                        <img class="lazyload" data-srcset="${this._getSrcsetImages(val.attributes)}" data-sizes="auto" width="${val.attributes.width}" height="${val.attributes.height}" src="${window.ENV.API_ASSETS_BASE_PATH + val.attributes.formats.small.url}"/>
                      </a>
                    </li>`, "")}
                  </ul>
                </div>
                <div class="ma-slideshow__controls glide__arrows" data-glide-el="controls">
                  <button class="glide__arrow glide__arrow--prev" data-glide-dir="&lt;">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 18.8 30.3" style="enable-background:new 0 0 18.8 30.3;" xml:space="preserve">
                      <polygon fill="#2A2827" points="16.3,30.3 18.8,27.5 5.4,15.1 18.8,2.7 16.3,0 0,15.1"></polygon>
                    </svg>
                  </button>
                  <button class="glide__arrow glide__arrow--next" data-glide-dir="&gt;">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 18.8 30.3" style="enable-background:new 0 0 18.8 30.3;" xml:space="preserve">
                      <polygon fill="#2A2827" points="2.5,0 0,2.8 13.4,15.2 0,27.6 2.5,30.3 18.8,15.2"></polygon>
                    </svg>
                  </button>
                </div>
              </div>
            </div>`;
    }
    _getImageHtml(imageData) {
        return `<div class="fullwidth-image">
              <a data-pswp-width="${imageData.attributes.width}" data-pswp-height="${imageData.attributes.height}" data-pswp-src="${window.ENV.API_ASSETS_BASE_PATH + imageData.attributes.url}">
                <img class="lazyload" data-srcset="${this._getSrcsetImages(imageData.attributes)}" data-sizes="auto" width="${imageData.attributes.width}" height="${imageData.attributes.height}" src="${window.ENV.API_ASSETS_BASE_PATH + imageData.attributes.formats.small.url}"/>
              </a>
            </div>`;
    }
    _getSrcsetImages(imagesData) {
        let srcset = "";
        if (imagesData.formats.small) srcset += `${window.ENV.API_ASSETS_BASE_PATH + imagesData.formats.small.url} ${imagesData.formats.small.width}w, `;
        if (imagesData.formats.medium) srcset += `${window.ENV.API_ASSETS_BASE_PATH + imagesData.formats.medium.url} ${imagesData.formats.medium.width}w, `;
        if (imagesData.formats.large) srcset += `${window.ENV.API_ASSETS_BASE_PATH + imagesData.formats.large.url} ${imagesData.formats.large.width}w, `;
        srcset += `${window.ENV.API_ASSETS_BASE_PATH + imagesData.url} ${imagesData.width}w`;
        return srcset;
    }
    _initPhotoSwipe(el) {
        const pswpElement = document.querySelectorAll(".pswp")[0];
        const options = {
            index: 0,
            mainClass: "pswp--minimal--dark",
            barsSize: {
                top: 10,
                bottom: 10
            },
            captionEl: true,
            fullscreenEl: false,
            shareEl: false,
            bgOpacity: 0.65,
            tapToClose: true,
            tapToToggleControls: false,
            history: false
        };
        el.addEventListener("click", (e)=>{
            e.preventDefault();
            //if is dragging, don't open photoswipe
            if (el.getAttribute("draggable") == "false") return;
            const pswpItems = [];
            options.index = 1;
            const item = {
                src: el.getAttribute("data-pswp-src"),
                w: el.getAttribute("data-pswp-width"),
                h: el.getAttribute("data-pswp-height")
            };
            pswpItems.push(item);
            const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, pswpItems, options);
            gallery.init();
        });
    }
}
var $09fdde2ebe540f0f$export$2e2bcd8739ae039 = $09fdde2ebe540f0f$var$GenericPage;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $4ba4e8b6e1243a8b$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
function $4ba4e8b6e1243a8b$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
// do not edit .js files directly - edit src/index.jst
var $4ba4e8b6e1243a8b$var$fastDeepEqual = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};
var $4ba4e8b6e1243a8b$var$isEqual = /*@__PURE__*/ $4ba4e8b6e1243a8b$var$getDefaultExportFromCjs($4ba4e8b6e1243a8b$var$fastDeepEqual);
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at.
 *
 *      Http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4ba4e8b6e1243a8b$export$19fc78b4b5aa5d0d = "__googleMapsScriptId";
/**
 * The status of the [[Loader]].
 */ var $4ba4e8b6e1243a8b$export$406cfe323c8bb8e4;
(function(LoaderStatus) {
    LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
    LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
    LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
    LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
})($4ba4e8b6e1243a8b$export$406cfe323c8bb8e4 || ($4ba4e8b6e1243a8b$export$406cfe323c8bb8e4 = {}));
/**
 * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
 * dynamically using
 * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 * It works by dynamically creating and appending a script node to the the
 * document head and wrapping the callback function so as to return a promise.
 *
 * ```
 * const loader = new Loader({
 *   apiKey: "",
 *   version: "weekly",
 *   libraries: ["places"]
 * });
 *
 * loader.load().then((google) => {
 *   const map = new google.maps.Map(...)
 * })
 * ```
 */ class $4ba4e8b6e1243a8b$export$3b0d6d7590275603 {
    /**
     * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
     * using this library, instead the defaults are set by the Google Maps
     * JavaScript API server.
     *
     * ```
     * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
     * ```
     */ constructor({ apiKey: apiKey, authReferrerPolicy: authReferrerPolicy, channel: channel, client: client, id: id = $4ba4e8b6e1243a8b$export$19fc78b4b5aa5d0d, language: language, libraries: libraries = [], mapIds: mapIds, nonce: nonce, region: region, retries: retries = 3, url: url = "https://maps.googleapis.com/maps/api/js", version: version }){
        this.callbacks = [];
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.apiKey = apiKey;
        this.authReferrerPolicy = authReferrerPolicy;
        this.channel = channel;
        this.client = client;
        this.id = id || $4ba4e8b6e1243a8b$export$19fc78b4b5aa5d0d; // Do not allow empty string
        this.language = language;
        this.libraries = libraries;
        this.mapIds = mapIds;
        this.nonce = nonce;
        this.region = region;
        this.retries = retries;
        this.url = url;
        this.version = version;
        if ($4ba4e8b6e1243a8b$export$3b0d6d7590275603.instance) {
            if (!$4ba4e8b6e1243a8b$var$isEqual(this.options, $4ba4e8b6e1243a8b$export$3b0d6d7590275603.instance.options)) throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify($4ba4e8b6e1243a8b$export$3b0d6d7590275603.instance.options)}`);
            return $4ba4e8b6e1243a8b$export$3b0d6d7590275603.instance;
        }
        $4ba4e8b6e1243a8b$export$3b0d6d7590275603.instance = this;
    }
    get options() {
        return {
            version: this.version,
            apiKey: this.apiKey,
            channel: this.channel,
            client: this.client,
            id: this.id,
            libraries: this.libraries,
            language: this.language,
            region: this.region,
            mapIds: this.mapIds,
            nonce: this.nonce,
            url: this.url,
            authReferrerPolicy: this.authReferrerPolicy
        };
    }
    get status() {
        if (this.errors.length) return $4ba4e8b6e1243a8b$export$406cfe323c8bb8e4.FAILURE;
        if (this.done) return $4ba4e8b6e1243a8b$export$406cfe323c8bb8e4.SUCCESS;
        if (this.loading) return $4ba4e8b6e1243a8b$export$406cfe323c8bb8e4.LOADING;
        return $4ba4e8b6e1243a8b$export$406cfe323c8bb8e4.INITIALIZED;
    }
    get failed() {
        return this.done && !this.loading && this.errors.length >= this.retries + 1;
    }
    /**
     * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
     *
     * @ignore
     * @deprecated
     */ createUrl() {
        let url = this.url;
        url += `?callback=__googleMapsCallback&loading=async`;
        if (this.apiKey) url += `&key=${this.apiKey}`;
        if (this.channel) url += `&channel=${this.channel}`;
        if (this.client) url += `&client=${this.client}`;
        if (this.libraries.length > 0) url += `&libraries=${this.libraries.join(",")}`;
        if (this.language) url += `&language=${this.language}`;
        if (this.region) url += `&region=${this.region}`;
        if (this.version) url += `&v=${this.version}`;
        if (this.mapIds) url += `&map_ids=${this.mapIds.join(",")}`;
        if (this.authReferrerPolicy) url += `&auth_referrer_policy=${this.authReferrerPolicy}`;
        return url;
    }
    deleteScript() {
        const script = document.getElementById(this.id);
        if (script) script.remove();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     * @deprecated, use importLibrary() instead.
     */ load() {
        return this.loadPromise();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     *
     * @ignore
     * @deprecated, use importLibrary() instead.
     */ loadPromise() {
        return new Promise((resolve, reject)=>{
            this.loadCallback((err)=>{
                if (!err) resolve(window.google);
                else reject(err.error);
            });
        });
    }
    importLibrary(name) {
        this.execute();
        return google.maps.importLibrary(name);
    }
    /**
     * Load the Google Maps JavaScript API script with a callback.
     * @deprecated, use importLibrary() instead.
     */ loadCallback(fn) {
        this.callbacks.push(fn);
        this.execute();
    }
    /**
     * Set the script on document.
     */ setScript() {
        var _a, _b;
        if (document.getElementById(this.id)) {
            // TODO wrap onerror callback for cases where the script was loaded elsewhere
            this.callback();
            return;
        }
        const params = {
            key: this.apiKey,
            channel: this.channel,
            client: this.client,
            libraries: this.libraries.length && this.libraries,
            v: this.version,
            mapIds: this.mapIds,
            language: this.language,
            region: this.region,
            authReferrerPolicy: this.authReferrerPolicy
        };
        // keep the URL minimal:
        Object.keys(params).forEach(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (key)=>!params[key] && delete params[key]);
        if (!((_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.importLibrary)) // tweaked copy of https://developers.google.com/maps/documentation/javascript/load-maps-js-api#dynamic-library-import
        // which also sets the base url, the id, and the nonce
        /* eslint-disable */ ((g)=>{
            // @ts-ignore
            let h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window;
            // @ts-ignore
            b = b[c] || (b[c] = {});
            // @ts-ignore
            const d = b.maps || (b.maps = {}), r = new Set(), e = new URLSearchParams(), u = ()=>// @ts-ignore
                h || (h = new Promise((f, n)=>$4ba4e8b6e1243a8b$var$__awaiter(this, void 0, void 0, function*() {
                        var _a;
                        yield a = m.createElement("script");
                        a.id = this.id;
                        e.set("libraries", [
                            ...r
                        ] + "");
                        // @ts-ignore
                        for(k in g)e.set(k.replace(/[A-Z]/g, (t)=>"_" + t[0].toLowerCase()), g[k]);
                        e.set("callback", c + ".maps." + q);
                        a.src = this.url + `?` + e;
                        d[q] = f;
                        a.onerror = ()=>h = n(Error(p + " could not load."));
                        // @ts-ignore
                        a.nonce = this.nonce || ((_a = m.querySelector("script[nonce]")) === null || _a === void 0 ? void 0 : _a.nonce) || "";
                        m.head.append(a);
                    })));
            // @ts-ignore
            d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n)=>r.add(f) && u().then(()=>d[l](f, ...n));
        })(params);
        // While most libraries populate the global namespace when loaded via bootstrap params,
        // this is not the case for "marker" when used with the inline bootstrap loader
        // (and maybe others in the future). So ensure there is an importLibrary for each:
        const libraryPromises = this.libraries.map((library)=>this.importLibrary(library));
        // ensure at least one library, to kick off loading...
        if (!libraryPromises.length) libraryPromises.push(this.importLibrary("core"));
        Promise.all(libraryPromises).then(()=>this.callback(), (error)=>{
            const event = new ErrorEvent("error", {
                error: error
            }); // for backwards compat
            this.loadErrorCallback(event);
        });
    }
    /**
     * Reset the loader state.
     */ reset() {
        this.deleteScript();
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.onerrorEvent = null;
    }
    resetIfRetryingFailed() {
        if (this.failed) this.reset();
    }
    loadErrorCallback(e) {
        this.errors.push(e);
        if (this.errors.length <= this.retries) {
            const delay = this.errors.length * Math.pow(2, this.errors.length);
            console.error(`Failed to load Google Maps script, retrying in ${delay} ms.`);
            setTimeout(()=>{
                this.deleteScript();
                this.setScript();
            }, delay);
        } else {
            this.onerrorEvent = e;
            this.callback();
        }
    }
    callback() {
        this.done = true;
        this.loading = false;
        this.callbacks.forEach((cb)=>{
            cb(this.onerrorEvent);
        });
        this.callbacks = [];
    }
    execute() {
        this.resetIfRetryingFailed();
        if (this.done) this.callback();
        else {
            // short circuit and warn if google.maps is already loaded
            if (window.google && window.google.maps && window.google.maps.version) {
                console.warn("Google Maps already loaded outside @googlemaps/js-api-loader.This may result in undesirable behavior as options and script parameters may not match.");
                this.callback();
                return;
            }
            if (this.loading) ;
            else {
                this.loading = true;
                this.setScript();
            }
        }
    }
}



class $d0851602ff25cb8a$export$2e2bcd8739ae039 {
    constructor(pageEl, googleMapsOptions){
        this.pageEl = pageEl;
        this.googleMapsOptions = googleMapsOptions;
        this.map = undefined;
        this.itinerariesData = undefined;
        this.converter = new showdown.Converter();
        const urlParams = new URLSearchParams(window.location.search);
        this.itineraryId = urlParams.get("id");
        const loader = new (0, $4ba4e8b6e1243a8b$export$3b0d6d7590275603)({
            ...googleMapsOptions
        });
        let requestPath = window.ENV.API_BASE_PATH + "/itineraries?populate=deep&locale=" + window.language;
        if (this.itineraryId) requestPath = window.ENV.API_BASE_PATH + "/itineraries/" + this.itineraryId + "?populate=deep&locale=" + window.language;
        fetch(requestPath).then((response)=>response.json()).then((data)=>{
            this.itinerariesData = data.data;
            loader.load().then(async ()=>this._initMap());
        }).catch((error)=>console.error("Erro:", error));
        this.pageEl.querySelector(".point-info__container").addEventListener("click", ()=>this._closePointInfo());
        this.pageEl.querySelector(".point-info__close-icon").addEventListener("click", ()=>this._closePointInfo());
        this.pageEl.querySelector(".point-info__content").addEventListener("click", (e)=>e.stopPropagation());
    }
    async _initMap() {
        const { Map: Map } = await google.maps.importLibrary("maps");
        const { AdvancedMarkerElement: AdvancedMarkerElement, PinElement: PinElement } = await google.maps.importLibrary("marker");
        let centerPoint, firstPoint;
        if (this.itinerariesData[0].attributes.points.data.length > 0) {
            firstPoint = this.itinerariesData[0].attributes.points.data[0]; //temporary TODO add center point to Strapi
            centerPoint = this.itinerariesData[0].attributes.center_latitude && this.itinerariesData[0].attributes.center_longitude ? {
                lat: parseFloat(this.itinerariesData[0].attributes.center_latitude),
                lng: parseFloat(this.itinerariesData[0].attributes.center_longitude)
            } : {
                lat: parseFloat(firstPoint.attributes.latitude),
                lng: parseFloat(firstPoint.attributes.longitude)
            };
        }
        this.map = new Map(this.pageEl.querySelector("#googlemaps-map"), {
            center: centerPoint ? centerPoint : {
                lat: 40.1970713,
                lng: -8.4082688
            },
            zoom: this.itinerariesData[0].attributes.center_zoom || 16,
            fullscreenControl: false,
            mapId: "6167a4adba0000d5"
        });
        this._getGlobalOptions().then((homeData)=>{
            let kmlLayer;
            let kmlLayerSecondary;
            if (homeData.attributes.kml_file?.data) kmlLayer = new google.maps.KmlLayer(window.ENV.API_ASSETS_BASE_PATH + homeData.attributes.kml_file.data.attributes.url, {
                suppressInfoWindows: true,
                preserveViewport: true
            });
            if (homeData.attributes.kml_file_secondary?.data) kmlLayerSecondary = new google.maps.KmlLayer(window.ENV.API_ASSETS_BASE_PATH + homeData.attributes.kml_file_secondary.data.attributes.url, {
                suppressInfoWindows: false,
                preserveViewport: true
            });
            if (kmlLayer) {
                google.maps.event.addListener(kmlLayer, "status_changed", function() {
                    if (kmlLayerSecondary) kmlLayerSecondary.setMap(this.map);
                });
                kmlLayer.setMap(this.map);
            }
        });
        this.itinerariesData.map((itinerary)=>{
            const itineraryCoordinates = itinerary.attributes.points.data.map((point)=>{
                return {
                    lat: parseFloat(point.attributes.latitude),
                    lng: parseFloat(point.attributes.longitude),
                    id: point.id,
                    color: point.attributes.category.data?.attributes.color,
                    text_color: point.attributes.category.data?.attributes.text_color,
                    img: point.attributes.category.data?.attributes.marker.data ? window.ENV.API_ASSETS_BASE_PATH + point.attributes.category.data?.attributes.marker.data?.attributes.url : undefined
                };
            });
            itineraryCoordinates.forEach((point, index)=>{
                this._addMarker(point, index, AdvancedMarkerElement, PinElement);
            });
        });
    }
    _getGlobalOptions() {
        return fetch(window.ENV.API_BASE_PATH + "/global-option/?populate=deep&locale=" + window.language).then((response)=>response.json()).then((data)=>data.data);
    }
    _addMarker(point, index, AdvancedMarkerElement, PinElement) {
        const markerImg = document.createElement("img");
        if (point.img) markerImg.src = point.img;
        const pinElement = new PinElement({
            glyph: `${index + 1}`,
            glyphColor: point.text_color == "dark" ? "black" : "white",
            background: point.color || "#6A998E",
            borderColor: "white",
            scale: 1.1
        });
        const marker = new AdvancedMarkerElement({
            position: {
                lat: point.lat,
                lng: point.lng
            },
            map: this.map,
            content: point.img ? markerImg : pinElement.element
        });
        marker.addListener("click", ()=>this._openPointInfo(index, point.id));
    }
    _openPointInfo(index, id) {
        this.pageEl.querySelector(".point-info").classList.add("point-info--open");
        this._getPointInfo(index, id);
    }
    _closePointInfo() {
        this.pageEl.querySelector(".point-info").scrollTo({
            top: 0,
            behavior: "smooth"
        });
        this.pageEl.querySelector(".point-info").classList.remove("point-info--open");
        this.pageEl.querySelector(".point-info").scrollTo(0, 0);
    }
    _getPointInfo(index, id) {
        fetch(window.ENV.API_BASE_PATH + "/points/" + id + "?populate=deep&locale=" + window.language).then((response)=>response.json()).then((data)=>{
            this._addPointInfo(index, data.data);
        }).catch((error)=>console.error("Erro:", error));
    }
    _addPointInfo(index, pointData) {
        this.pageEl.querySelector("[data-point-content]").innerHTML = `<div class="point-info__heading">
        <div class="point-info__num">
          ${pointData.attributes.category.data?.attributes.marker.data ? `<img src="${window.ENV.API_ASSETS_BASE_PATH + pointData.attributes.category.data?.attributes.marker.data?.attributes.url}">` : `<svg viewBox="0 0 24 24"><defs><style>.cls-1{fill:none;}.cls-2{fill:${pointData.attributes.category.data?.attributes.color || "#6A998E"};}.cls-3{font-size:7px;fill:${pointData.attributes.category.data?.attributes.text_color === "dark" ? "black" : "white"};font-family:OpenSansRoman-Bold, Open Sans;font-weight:700;}</style></defs><path class="cls-1" d="M0,0H24V24H0Z"/><path class="cls-2" d="M12,2A7,7,0,0,0,5,9c0,5.25,7,13,7,13s7-7.75,7-13A7,7,0,0,0,12,2Z"/><text class="cls-3"  x="12" y="12" text-anchor="middle">${index + 1}</text></svg></span>`}
        </div>
        <div class="point-info__heading-titles">
          ${pointData.attributes.category.data ? `<h5>${pointData.attributes.category.data?.attributes.name}</h5>` : ""}
          <h2>${pointData.attributes.name}</h2>
        </div>
      </div>
      ${pointData.attributes.type ? `<h5>${pointData.attributes.type}</h5>` : ""}
      <ul class="point-info__details">
        ${pointData.attributes.maps_link ? `<a class="point-info__detail-item" href="${pointData.attributes.maps_link}" target="_blank">
              <i class="fas fa-map"></i>Google Maps
            </a>` : ""}
        ${pointData.attributes.link ? `<a class="point-info__detail-item" href="${pointData.attributes.link}" target="_blank">
              <i class="fas fa-link"></i>Website
            </a>` : ""}
      </ul>
      ${pointData.attributes.description ? `<div class="point-info__description" data-point-description="data-point-description">${this.converter.makeHtml(pointData.attributes.description)}</div>` : ""}
      ${pointData.attributes.notes ? `<div class="point-info__notes">${this.converter.makeHtml(pointData.attributes.notes)}</div>` : ""}


      ${pointData.attributes.images.data ? pointData.attributes.images.data?.length == 1 ? this._getImageHtml(pointData.attributes.images.data[0]) : this._getSlideshowHtml(pointData.attributes.images.data) : ""}`;
        if (pointData.attributes.images.data?.length == 1) this._initPhotoSwipe(this.pageEl.querySelector("[data-point-content] [data-pswp-src]"));
        else if (pointData.attributes.images.data?.length > 0) new (0, $3f56b7aaaa640ed3$export$2e2bcd8739ae039)(this.pageEl.querySelector("[data-point-content] .ma-slideshow"));
    }
    _getImageHtml(imageData) {
        return `<div class="fullwidth-image">
              <a data-pswp-width="${imageData.attributes.width}" data-pswp-height="${imageData.attributes.height}" data-pswp-src="${window.ENV.API_ASSETS_BASE_PATH + imageData.attributes.url}">
                <img class="lazyload" data-srcset="${this._getSrcsetImages(imageData.attributes)}" data-sizes="auto" width="${imageData.attributes.width}" height="${imageData.attributes.height}" src="${window.ENV.API_ASSETS_BASE_PATH + imageData.attributes.formats.small.url}"/>
              </a>
            </div>`;
    }
    _getSlideshowHtml(imagesData) {
        return `<div class="ma-slideshow" id="ma-slideshow-1">
              <div class="glide" data-glide-slideshow="data-glide-slideshow">
                <div class="glide__track" data-glide-el="track">
                  <ul class="glide__slides">
                  ${imagesData.reduce((acc, val)=>acc + `<li class="glide__slide">
                      <a data-pswp-width="${val.attributes.width}" data-pswp-height="${val.attributes.height}" data-pswp-src="${window.ENV.API_ASSETS_BASE_PATH + val.attributes.url}">
                        <img class="lazyload" data-srcset="${this._getSrcsetImages(val.attributes)}" data-sizes="auto" width="${val.attributes.width}" height="${val.attributes.height}" src="${window.ENV.API_ASSETS_BASE_PATH + val.attributes.formats.small.url}"/>
                      </a>
                    </li>`, "")}
                  </ul>
                </div>
                <div class="ma-slideshow__controls glide__arrows" data-glide-el="controls">
                  <button class="glide__arrow glide__arrow--prev" data-glide-dir="&lt;">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 18.8 30.3" style="enable-background:new 0 0 18.8 30.3;" xml:space="preserve">
                      <polygon fill="#2A2827" points="16.3,30.3 18.8,27.5 5.4,15.1 18.8,2.7 16.3,0 0,15.1"></polygon>
                    </svg>
                  </button>
                  <button class="glide__arrow glide__arrow--next" data-glide-dir="&gt;">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 18.8 30.3" style="enable-background:new 0 0 18.8 30.3;" xml:space="preserve">
                      <polygon fill="#2A2827" points="2.5,0 0,2.8 13.4,15.2 0,27.6 2.5,30.3 18.8,15.2"></polygon>
                    </svg>
                  </button>
                </div>
              </div>
            </div>`;
    }
    _getSrcsetImages(imagesData) {
        let srcset = "";
        if (imagesData.formats.small) srcset += `${window.ENV.API_ASSETS_BASE_PATH + imagesData.formats.small.url} ${imagesData.formats.small.width}w, `;
        if (imagesData.formats.medium) srcset += `${window.ENV.API_ASSETS_BASE_PATH + imagesData.formats.medium.url} ${imagesData.formats.medium.width}w, `;
        if (imagesData.formats.large) srcset += `${window.ENV.API_ASSETS_BASE_PATH + imagesData.formats.large.url} ${imagesData.formats.large.width}w, `;
        srcset += `${window.ENV.API_ASSETS_BASE_PATH + imagesData.url} ${imagesData.width}w`;
        return srcset;
    }
    _initPhotoSwipe(el) {
        const pswpElement = document.querySelectorAll(".pswp")[0];
        const options = {
            index: 0,
            mainClass: "pswp--minimal--dark",
            barsSize: {
                top: 10,
                bottom: 10
            },
            captionEl: true,
            fullscreenEl: false,
            shareEl: false,
            bgOpacity: 0.65,
            tapToClose: true,
            tapToToggleControls: false,
            history: false
        };
        el.addEventListener("click", (e)=>{
            e.preventDefault();
            //if is dragging, don't open photoswipe
            if (el.getAttribute("draggable") == "false") return;
            const pswpItems = [];
            options.index = 1;
            const item = {
                src: el.getAttribute("data-pswp-src"),
                w: el.getAttribute("data-pswp-width"),
                h: el.getAttribute("data-pswp-height")
            };
            pswpItems.push(item);
            const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, pswpItems, options);
            gallery.init();
        });
    }
}


class $968c0137354a5edb$export$2e2bcd8739ae039 {
    constructor(){
        this.language = undefined;
        if (localStorage.getItem("language")) this._setLanguage(localStorage.getItem("language"));
        else this._setLanguage(navigator.language.includes("pt") ? "pt" : "en", true);
        this._updateLabels();
        document.querySelectorAll("[data-language]").forEach((el)=>{
            el.addEventListener("click", (e)=>{
                localStorage.setItem("language", el.getAttribute("data-language"));
                location.reload();
            });
        });
    }
    _updateLabels() {
        const labels = {
            itineraries: {
                pt: "Roteiros",
                en: "Itineraries"
            },
            "itinerary-and-points": {
                pt: "Rota e Pontos de interesse",
                en: "Itinerary and Points of interest",
                es: "Ruta y Puntos de Inter\xe9s"
            },
            about: {
                pt: "Sobre",
                en: "About",
                es: "Acerca"
            },
            map: {
                pt: "Mapa",
                en: "Map",
                es: "Mapa"
            },
            language: {
                pt: "L\xedngua ",
                en: "Language ",
                es: "Idioma "
            },
            "how-to-get-there": {
                pt: "Como chegar",
                en: "How to get there",
                es: "C\xf3mo llegar"
            },
            "safety-advice": {
                pt: "Regras de conduta e seguran\xe7a",
                en: "Safety Advice",
                es: "Consejo de Seguridad"
            },
            signage: {
                pt: "Sinal\xe9tica",
                en: "Signage",
                es: "Se\xf1alizaci\xf3n"
            },
            community: {
                pt: "Comunidade",
                en: "Community",
                es: "Comunidad"
            },
            segments: {
                pt: "Segmentos",
                en: "Segments",
                es: "Segmentos"
            },
            gpx: {
                pt: "Download",
                en: "Download",
                es: "Descarregar"
            }
        };
        const slugs = {
            about: {
                pt: "sobre",
                en: "about",
                es: "acerca"
            },
            "how-to-get-there": {
                pt: "como-chegar",
                en: "how-to-get-there",
                es: "como-llegar"
            },
            "safety-advice": {
                pt: "conselhos-de-seguranca",
                en: "safety-advice",
                es: "consejo-de-seguridad"
            },
            signage: {
                pt: "sinaletica",
                en: "signage",
                es: "senalizacion"
            },
            community: {
                pt: "comunidade",
                en: "community",
                es: "comunidad"
            },
            gpx: {
                pt: "gpx",
                en: "gpx_en",
                es: "gpx_es"
            }
        };
        if (document.querySelector('[data-menu-opt="map"]')) document.querySelector('[data-menu-opt="map"]').innerHTML = labels["map"][window.language];
        if (document.querySelector('[data-menu-opt="itineraries"]')) document.querySelector('[data-menu-opt="itineraries"]').innerHTML = labels["itineraries"][window.language];
        if (document.querySelector('[data-menu-opt="itinerary-and-points"]')) document.querySelector('[data-menu-opt="itinerary-and-points"]').innerHTML = labels["itinerary-and-points"][window.language];
        if (document.querySelector('[data-page-title="itinerary-and-points"]')) document.querySelector('[data-page-title="itinerary-and-points"]').innerHTML = labels["itinerary-and-points"][window.language];
        if (document.querySelector('[data-menu-opt="about-label"]')) document.querySelector('[data-menu-opt="about-label"]').innerHTML = labels["about"][window.language];
        if (document.querySelector('[data-menu-opt="about-slug"]')) document.querySelector('[data-menu-opt="about-slug"]').setAttribute("href", `page/?slug=${slugs["about"][window.language]}`);
        if (document.querySelector('[data-menu-opt="language"]')) document.querySelector('[data-menu-opt="language"]').innerHTML = labels["language"][window.language];
        if (document.querySelector('[data-menu-opt="how-to-get-there"]')) {
            document.querySelector('[data-menu-opt="how-to-get-there"]').innerHTML = labels["how-to-get-there"][window.language];
            if (slugs["how-to-get-there"][window.language]) document.querySelector('[data-menu-opt="how-to-get-there"]').setAttribute("href", `page/?slug=${slugs["how-to-get-there"][window.language]}`);
        }
        if (document.querySelector('[data-menu-opt="safety-advice"]')) {
            document.querySelector('[data-menu-opt="safety-advice"]').innerHTML = labels["safety-advice"][window.language];
            if (slugs["safety-advice"][window.language]) document.querySelector('[data-menu-opt="safety-advice"]').setAttribute("href", `page/?slug=${slugs["safety-advice"][window.language]}`);
        }
        if (document.querySelector('[data-menu-opt="signage"]')) {
            document.querySelector('[data-menu-opt="signage"]').innerHTML = labels["signage"][window.language];
            if (slugs["signage"][window.language]) document.querySelector('[data-menu-opt="signage"]').setAttribute("href", `page/?slug=${slugs["signage"][window.language]}`);
        }
        if (document.querySelector('[data-menu-opt="community"]')) {
            document.querySelector('[data-menu-opt="community"]').innerHTML = labels["community"][window.language];
            if (slugs["community"][window.language]) document.querySelector('[data-menu-opt="community"]').setAttribute("href", `page/?slug=${slugs["community"][window.language]}`);
        }
        if (document.querySelector('[data-menu-opt="segments"]')) document.querySelector('[data-menu-opt="segments"]').innerHTML = labels["segments"][window.language];
        if (document.querySelector('[data-menu-opt="gpx"]')) {
            document.querySelector('[data-menu-opt="gpx"]').innerHTML = labels["gpx"][window.language];
            if (slugs["gpx"][window.language]) document.querySelector('[data-menu-opt="gpx"]').setAttribute("href", `page/?slug=${slugs["gpx"][window.language]}`);
        }
    }
    _setLanguage(newLanguage) {
        this.language = newLanguage;
        window.language = this.language;
        localStorage.setItem("language", this.language);
        if (document.querySelector("[data-current-language]")) document.querySelector("[data-current-language]").innerHTML = this.language;
        const languageUpdateEvent = new Event("language-update");
    }
}


class $11aace956046a496$export$2e2bcd8739ae039 {
    constructor(){
        this.storageKey = "ecovia-alert-dismissed";
        this.checkAndShowAlert();
    }
    checkAndShowAlert() {
        // Verifica se o utilizador já fechou o alerta
        const isDismissed = localStorage.getItem(this.storageKey);
        // Se não foi fechado anteriormente, mostra o alerta
        if (!isDismissed) this.createAlertModal();
    }
    createAlertModal() {
        // Cria o container do modal
        const modalOverlay = document.createElement("div");
        modalOverlay.className = "modal-alert-overlay";
        modalOverlay.id = "modal-alert";
        // HTML do modal
        modalOverlay.innerHTML = `
      <div class="modal-alert-container">
        <div class="modal-alert-header">
          <i class="fas fa-exclamation-triangle"></i>
          <button class="modal-alert-close" aria-label="Fechar alerta">
            <i class="fas fa-times"></i>
          </button>
        </div>
        
        <div class="modal-alert-content">
          <p>Informamos todos os utilizadores que, devido \xe0s condi\xe7\xf5es meteorol\xf3gicas adversas que se t\xeam feito sentir na nossa regi\xe3o, existem atualmente v\xe1rios segmentos da rota intransit\xe1veis em grande parte do percurso.</p>

          <p>Solicita-se a m\xe1xima cautela na utiliza\xe7\xe3o da via at\xe9 novas informa\xe7\xf5es.</p>

          <p><strong>Foram identificadas as seguintes situa\xe7\xf5es de risco:</strong></p>
          <ul>
            <li>Arribas inst\xe1veis</li>
            <li>Prote\xe7\xf5es de via ausentes</li>
            <li>Derrocadas na via</li>
            <li>Via submersa</li>
          </ul>

          <p>Antes de iniciar o percurso, por favor informe-se junto das autoridades locais sobre o estado atualizado da Ecovia.</p>

          <p>Agradecemos a compreens\xe3o e colabora\xe7\xe3o de todos.</p>
        </div>

        <div class="modal-alert-footer">
          <button class="modal-alert-btn-close">Fechar</button>
        </div>
      </div>
    `;
        // Adiciona o modal ao body
        document.body.appendChild(modalOverlay);
        // Event listeners para fechar
        const closeButton = modalOverlay.querySelector(".modal-alert-close");
        const closeButtonFooter = modalOverlay.querySelector(".modal-alert-btn-close");
        closeButton.addEventListener("click", ()=>this.dismissAlert(modalOverlay));
        closeButtonFooter.addEventListener("click", ()=>this.dismissAlert(modalOverlay));
        // Fecha ao clicar no overlay
        modalOverlay.addEventListener("click", (e)=>{
            if (e.target === modalOverlay) this.dismissAlert(modalOverlay);
        });
    }
    dismissAlert(modalElement) {
        // Guarda no localStorage que o utilizador fechou o alerta
        localStorage.setItem(this.storageKey, "true");
        // Remove o elemento do DOM com animação
        modalElement.classList.add("closing");
        setTimeout(()=>{
            modalElement.remove();
        }, 300);
    }
}


/*
 * DEBOUNCE
  var example = debounce(function() {
  }, 500);
 */ function $252b04cee0336183$var$debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}
/*
 * Add leading zeros
 * https://gist.github.com/endel/321925f6cafa25bbfbde
 */ Number.prototype.pad = function(size) {
    var sign = Math.sign(this) === -1 ? "-" : "";
    return sign + new Array(size).concat([
        Math.abs(this)
    ]).join("0").slice(-size);
};
/*
 * DOCUMENT READY
 */ new (0, $968c0137354a5edb$export$2e2bcd8739ae039);
$(document).ready(function() {
    //* Reload pages after 5 minutes inactive
    //Add localstorage reload-timeout
    let mouseMoveTimeout = undefined;
    const timoutReloadMilSec = 300000;
    const searchParams = new URLSearchParams(window.location.search);
    const reloadTimeout = searchParams.get("reload");
    if (localStorage.getItem("reload-timeout") == null) {
        if (reloadTimeout != null) localStorage.setItem("reload-timeout", true);
    }
    //Timeout reload
    if (localStorage.getItem("reload-timeout")) {
        mouseMoveTimeout = setTimeout(()=>{
            location.reload();
        }, timoutReloadMilSec);
        document.addEventListener("mousemove", ()=>{
            if (mouseMoveTimeout) clearTimeout(mouseMoveTimeout);
            mouseMoveTimeout = setTimeout(()=>{
                location.reload();
            }, timoutReloadMilSec);
        });
    }
    if (document.querySelectorAll(".ma-accordion").length === 0) document.body.classList.add("body-ready");
    if (document.querySelector("[data-go-back]")) document.querySelector("[data-go-back]").addEventListener("click", ()=>{
        if (window.location.href.includes("agenda")) {
            const searchParam = new URLSearchParams(window.location.search);
            if (searchParam.has("place") && document.referrer) window.location = "/rota-e-pontos-de-interesse";
            else window.location = "/";
        } else if (window.location.href.includes("actividade")) {
            if (document.referrer) window.history.back();
            else window.location = "/";
        } else window.location = "/";
    });
    if (document.querySelector("#homepage")) {
        new (0, $09bad0736b074fc1$export$2e2bcd8739ae039);
        new (0, $11aace956046a496$export$2e2bcd8739ae039);
    }
    //About page
    const genericPageEl = document.querySelector(".generic-page");
    if (genericPageEl && searchParams.has("slug")) new (0, $09fdde2ebe540f0f$export$2e2bcd8739ae039)(genericPageEl, searchParams.get("slug"));
    //Info itinerary page
    const infoItineraryPageEl = document.querySelector("#info-page");
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("id");
    if (infoItineraryPageEl) new (0, $09fdde2ebe540f0f$export$2e2bcd8739ae039)(infoItineraryPageEl, "/itineraries/" + id);
    //Itinerary page
    const itineraryPageEl = document.querySelector("#itinerary-page");
    if (itineraryPageEl) new (0, $d0851602ff25cb8a$export$2e2bcd8739ae039)(itineraryPageEl, {
        apiKey: ENV.GOOGLE_MAPS_API_KEY,
        v: "quarterly"
    });
});

})();
//# sourceMappingURL=index.8194b20d.js.map
